import { getMenuInitialState, getMenuInitialStateForSaving } from './chunk-TKRJWY2U.mjs';
import { ITEM_INITIAL_STATE } from './chunk-IGSXE2BX.mjs';
import { getIsSaveButtonEnabledCore } from './chunk-7MMV2ZSX.mjs';
import { EMPTY_HOT_BUTTON } from './chunk-EN7ENLN6.mjs';
import { discountReasonsDropdownFactory, voidReasonsDropdownFactory } from './chunk-TSQW5WCO.mjs';
import { settingsDashboardsCardFactory } from './chunk-CCXO7AZP.mjs';
import { settingsRolesCardFactory } from './chunk-P3UA45O4.mjs';
import { selectLoggedInRoleId, selectUsers } from './chunk-YLY6KHID.mjs';
import { ROLE_INITIAL_STATE } from './chunk-OQ3OIKOT.mjs';
import { dropdownMenuTypeOptionFactory, menuTypeCardFactory } from './chunk-CNNXVQ5L.mjs';
import { menuItemGroupCardFactory } from './chunk-EEE54PHW.mjs';
import { dropdownAllReportingGroupsOptionFactory, menuReportingGroupCardFactory } from './chunk-C5AX5WMK.mjs';
import { menuSpecialCardFactory, dropdownAllLocationOptionFactory } from './chunk-XGMI2YD6.mjs';
import { dropdownSubcategoryOptionFactory } from './chunk-QODWPB46.mjs';
import { locationGroupToLocationFactory, locationsListFactory } from './chunk-R5V3I2XY.mjs';
import { dropdownAllCategoryOptionFactory } from './chunk-SCXUJWSP.mjs';
import { menuComboCardFactoryCore } from './chunk-KUMI3MOI.mjs';
import { menuDiscountCardFactory } from './chunk-KCJDKAN3.mjs';
import { menuIngredientCardFactory } from './chunk-OMAKIOP6.mjs';
import { menuItemCardFactoryCore } from './chunk-MFMTSPFX.mjs';
import { NULLISH_DATE, TSR_ORDER_TYPES } from './chunk-3YIOW4BW.mjs';
import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';
import { __export, __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import isEmpty from 'lodash/isEmpty';
import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import cloneDeep from 'lodash/cloneDeep';
import i18next from 'i18next';
import startCase from 'lodash/startCase';
import { DateTime, Duration } from 'luxon';
import get from 'lodash/get';

// src/state/selectors/settingsSelectors.ts
var settingsSelectors_exports = {};
__export(settingsSelectors_exports, {
  actualSettingsVersionSelector: () => actualSettingsVersionSelector,
  adsSelector: () => adsSelector,
  areSettingsMasterModeSelector: () => areSettingsMasterModeSelector,
  canSwipeAndDeleteTicketElementSelector: () => canSwipeAndDeleteTicketElementSelector,
  createSettingsErrorSelector: () => createSettingsErrorSelector,
  createSettingsSectionSelector: () => createSettingsSectionSelector,
  currentDevicesSelector: () => currentDevicesSelector,
  currentGeneralSettingsSelector: () => currentGeneralSettingsSelector,
  currentGuestCheckSettingsSelector: () => currentGuestCheckSettingsSelector,
  currentGuestReceiptSettingsSelector: () => currentGuestReceiptSettingsSelector,
  currentKitchenTicketSettingsSelector: () => currentKitchenTicketSettingsSelector,
  currentLicenseSettingsSettingsSelector: () => currentLicenseSettingsSettingsSelector,
  currentLicenseSpecificPrintingRulesSettingsSelector: () => currentLicenseSpecificPrintingRulesSettingsSelector,
  currentLicensesSelector: () => currentLicensesSelector,
  currentLocationLicenseSpecificPrintingRulesSettingsSelector: () => currentLocationLicenseSpecificPrintingRulesSettingsSelector,
  currentLocationPrintingRulesSettingsSelector: () => currentLocationPrintingRulesSettingsSelector,
  currentOnlineOrderingSettingsSelector: () => currentOnlineOrderingSettingsSelector,
  currentPaymentsSettingsSelector: () => currentPaymentsSettingsSelector,
  currentPrepStationsSelector: () => currentPrepStationsSelector,
  currentPrepStationsSettingsSelector: () => currentPrepStationsSettingsSelector,
  currentPrintersSelector: () => currentPrintersSelector,
  currentPrintingRulesSettingsModeSelector: () => currentPrintingRulesSettingsModeSelector,
  currentPrintingRulesSettingsSelector: () => currentPrintingRulesSettingsSelector,
  currentRegisterTicketSettingsSelector: () => currentRegisterTicketSettingsSelector,
  currentTabletsSelector: () => currentTabletsSelector,
  currentTaxesSettingsSelector: () => currentTaxesSettingsSelector,
  currentTerminalsSelector: () => currentTerminalsSelector,
  customTendersSelector: () => customTendersSelector,
  defaultMenuTypeTimesSelector: () => defaultMenuTypeTimesSelector,
  devicesSelector: () => devicesSelector,
  licensesSelector: () => licensesSelector,
  makeSelectSettingsData: () => makeSelectSettingsData,
  modifierTagsSelector: () => modifierTagsSelector,
  openItemTypesSelector: () => openItemTypesSelector,
  orderSeatTagsSelector: () => orderSeatTagsSelector,
  printersSelector: () => printersSelector,
  selectActiveCoursesArray: () => selectActiveCoursesArray,
  selectActualSettingsType: () => selectActualSettingsType,
  selectAllCoursesArray: () => selectAllCoursesArray,
  selectAllowForTableButton: () => selectAllowForTableButton,
  selectAllowOpenTabsOnTableLayout: () => selectAllowOpenTabsOnTableLayout,
  selectAllowUserToBeLoggedIntoMultipleTablets: () => selectAllowUserToBeLoggedIntoMultipleTablets,
  selectAttachNoSeatToToGo: () => selectAttachNoSeatToToGo,
  selectCoursingModeActive: () => selectCoursingModeActive,
  selectCurrentLicenseDefaultCheckPrinterId: () => selectCurrentLicenseDefaultCheckPrinterId,
  selectCurrentLicenseSettings: () => selectCurrentLicenseSettings,
  selectCurrentSettingActionOnSendButton: () => selectCurrentSettingActionOnSendButton,
  selectCurrentSettingActionOnSendStayButton: () => selectCurrentSettingActionOnSendStayButton,
  selectCurrentSettingAutoFilterTableTabsOrders: () => selectCurrentSettingAutoFilterTableTabsOrders,
  selectCurrentSettingDefaultOrderType: () => selectCurrentSettingDefaultOrderType,
  selectCurrentSettingDefaultRegisterScreen: () => selectCurrentSettingDefaultRegisterScreen,
  selectCurrentSettingNavigationActionOnCloseOrder: () => selectCurrentSettingNavigationActionOnCloseOrder,
  selectCurrentSettingNavigationActionOnFire: () => selectCurrentSettingNavigationActionOnFire,
  selectCurrentSettingNavigationActionOnPrintChecks: () => selectCurrentSettingNavigationActionOnPrintChecks,
  selectCurrentSettingNavigationActionOnTipPending: () => selectCurrentSettingNavigationActionOnTipPending,
  selectCurrentSettingQSROnOrderClosed: () => selectCurrentSettingQSROnOrderClosed,
  selectCurrentSettings: () => selectCurrentSettings,
  selectCurrentSettingsData: () => selectCurrentSettingsData,
  selectCurrentSettingsFinalDiffObject: () => selectCurrentSettingsFinalDiffObject,
  selectCurrentSettingsOriginalData: () => selectCurrentSettingsOriginalData,
  selectCurrentSettingsQSRSentToKitchenTrigger: () => selectCurrentSettingsQSRSentToKitchenTrigger,
  selectCurrentTaxesSettingsSelector: () => selectCurrentTaxesSettingsSelector,
  selectCurrentTimeZone: () => selectCurrentTimeZone,
  selectCustomTenders: () => selectCustomTenders,
  selectCustomizerPartition: () => selectCustomizerPartition,
  selectCustomizerShape: () => selectCustomizerShape,
  selectDashboardCardsList: () => selectDashboardCardsList,
  selectDashboards: () => selectDashboards,
  selectDefaultMenuTypeId: () => selectDefaultMenuTypeId,
  selectDefaultMenuTypeTimes: () => selectDefaultMenuTypeTimes,
  selectDefaultPrepStation: () => selectDefaultPrepStation,
  selectDefaultServiceAreaId: () => selectDefaultServiceAreaId,
  selectDefaultServiceAreaOption: () => selectDefaultServiceAreaOption,
  selectDefaultTipInput: () => selectDefaultTipInput,
  selectDevicesForDetailsScreen: () => selectDevicesForDetailsScreen,
  selectEGiftCardTerminalId: () => selectEGiftCardTerminalId,
  selectEnableDragDropForSeatPopover: () => selectEnableDragDropForSeatPopover,
  selectEnableEGiftIntegration: () => selectEnableEGiftIntegration,
  selectEndOfBusinessDay: () => selectEndOfBusinessDay,
  selectEnforceItemGroupOrderForCombos: () => selectEnforceItemGroupOrderForCombos,
  selectGeneralSettings: () => selectGeneralSettings,
  selectGeneralSettingsTranslationPath: () => selectGeneralSettingsTranslationPath,
  selectGroupRounds: () => selectGroupRounds,
  selectHasLocationOpenItems: () => selectHasLocationOpenItems,
  selectIsAutoTriggerEnabled: () => selectIsAutoTriggerEnabled,
  selectIsCateringAvailable: () => selectIsCateringAvailable,
  selectIsCoursingEnabled: () => selectIsCoursingEnabled,
  selectIsDefaultGuestCountOnNewOrder: () => selectIsDefaultGuestCountOnNewOrder,
  selectIsDeliveryAvailable: () => selectIsDeliveryAvailable,
  selectIsDineInAvailable: () => selectIsDineInAvailable,
  selectIsDualPricingEnabled: () => selectIsDualPricingEnabled,
  selectIsForTableButtonEnabled: () => selectIsForTableButtonEnabled,
  selectIsForceAllPaidOrdersToTipPendingEnabled: () => selectIsForceAllPaidOrdersToTipPendingEnabled,
  selectIsGuestCountSetToZeroOnToGoOrders: () => selectIsGuestCountSetToZeroOnToGoOrders,
  selectIsGuestCountSetToZeroWhenNoTable: () => selectIsGuestCountSetToZeroWhenNoTable,
  selectIsKeepTipPendingOrdersAssociatedToTableEnabled: () => selectIsKeepTipPendingOrdersAssociatedToTableEnabled,
  selectIsManualClosingRequiredPostTipEnabled: () => selectIsManualClosingRequiredPostTipEnabled,
  selectIsMapLayoutDragAndDropEnabled: () => selectIsMapLayoutDragAndDropEnabled,
  selectIsQSRModeActive: () => selectIsQSRModeActive,
  selectIsQuantityBar: () => selectIsQuantityBar,
  selectIsSeatOneDescriptionEnabled: () => selectIsSeatOneDescriptionEnabled,
  selectIsSeatingEnabledButSuppressedOnDevice: () => selectIsSeatingEnabledButSuppressedOnDevice,
  selectIsSeatingEnabledWithoutLicenseSuppress: () => selectIsSeatingEnabledWithoutLicenseSuppress,
  selectIsSeatingModeEnabled: () => selectIsSeatingModeEnabled,
  selectIsSendCourseButtonEnabled: () => selectIsSendCourseButtonEnabled,
  selectIsSendIndividualItemButtonDisabled: () => selectIsSendIndividualItemButtonDisabled,
  selectIsSettingsCreationMode: () => selectIsSettingsCreationMode,
  selectIsSettingsRemoteLocationMode: () => selectIsSettingsRemoteLocationMode,
  selectIsShowGuestCountEnabled: () => selectIsShowGuestCountEnabled,
  selectIsShowOrderDetailsForDefaultNewOrder: () => selectIsShowOrderDetailsForDefaultNewOrder,
  selectIsShowOrderDetailsForNewOrderEnabled: () => selectIsShowOrderDetailsForNewOrderEnabled,
  selectIsShowOrderDetailsForNewOrderQsrEnabled: () => selectIsShowOrderDetailsForNewOrderQsrEnabled,
  selectIsShowOrderDetailsForNewOrderTsrEnabled: () => selectIsShowOrderDetailsForNewOrderTsrEnabled,
  selectIsShowPriceFreeEnabled: () => selectIsShowPriceFreeEnabled,
  selectIsShowSendItemsModalEnabled: () => selectIsShowSendItemsModalEnabled,
  selectIsTicketAutoCollapSeLineItems: () => selectIsTicketAutoCollapSeLineItems,
  selectIsTicketSeatBarSettingEnabled: () => selectIsTicketSeatBarSettingEnabled,
  selectIsToGoAvailable: () => selectIsToGoAvailable,
  selectLicenseSettingsForDetailsScreen: () => selectLicenseSettingsForDetailsScreen,
  selectLicenseSpecificPrinterRulesForDetailsScreen: () => selectLicenseSpecificPrinterRulesForDetailsScreen,
  selectLicensesForDetailsScreen: () => selectLicensesForDetailsScreen,
  selectLocationCourses: () => selectLocationCourses,
  selectLocationDevices: () => selectLocationDevices,
  selectLocationFirePositionOnRegisterTicket: () => selectLocationFirePositionOnRegisterTicket,
  selectLocationGeneralSettings: () => selectLocationGeneralSettings,
  selectLocationLicenseSettings: () => selectLocationLicenseSettings,
  selectLocationModifierTags: () => selectLocationModifierTags,
  selectLocationPrepStationsSettings: () => selectLocationPrepStationsSettings,
  selectLocationPrinters: () => selectLocationPrinters,
  selectLocationRoles: () => selectLocationRoles,
  selectLocationSettings: () => selectLocationSettings,
  selectLocationShowNotificationMessageForPrinterErrors: () => selectLocationShowNotificationMessageForPrinterErrors,
  selectLocationShowPrinterStatusNotifications: () => selectLocationShowPrinterStatusNotifications,
  selectLocationTaxes: () => selectLocationTaxes,
  selectLocationTerminals: () => selectLocationTerminals,
  selectLoggedUserBehaviorOnNewOrder: () => selectLoggedUserBehaviorOnNewOrder,
  selectLoggedUserCanChangeMenuType: () => selectLoggedUserCanChangeMenuType,
  selectLoggedUserCanDeleteOrders: () => selectLoggedUserCanDeleteOrders,
  selectLoggedUserCanEditOtherUsersOrders: () => selectLoggedUserCanEditOtherUsersOrders,
  selectLoggedUserCanManageTables: () => selectLoggedUserCanManageTables,
  selectLoggedUserCanOverrideLicenseEditingId: () => selectLoggedUserCanOverrideLicenseEditingId,
  selectLoggedUserCanTransferOrders: () => selectLoggedUserCanTransferOrders,
  selectLoggedUserTransferPayments: () => selectLoggedUserTransferPayments,
  selectMasterSettings: () => selectMasterSettings,
  selectNumberOfPrepStationVersions: () => selectNumberOfPrepStationVersions,
  selectOpenItemTypes: () => selectOpenItemTypes,
  selectOpenItems: () => selectOpenItems,
  selectOrderTypesAvailable: () => selectOrderTypesAvailable,
  selectOrderTypesAvailableOnViewTables: () => selectOrderTypesAvailableOnViewTables,
  selectOverrideDefaultMenuTypeId: () => selectOverrideDefaultMenuTypeId,
  selectPaymentsCardCashPrice: () => selectPaymentsCardCashPrice,
  selectPaymentsDualPricing: () => selectPaymentsDualPricing,
  selectPaymentsListPrice: () => selectPaymentsListPrice,
  selectPaymentsServiceCharges: () => selectPaymentsServiceCharges,
  selectPinPadLayout: () => selectPinPadLayout,
  selectPrepStationVersionsOfCurrentKitchenTicketSettings: () => selectPrepStationVersionsOfCurrentKitchenTicketSettings,
  selectPrepStationsSettingsForDetailsScreen: () => selectPrepStationsSettingsForDetailsScreen,
  selectPrintOrderNumberOnSend: () => selectPrintOrderNumberOnSend,
  selectPrintReceiptOnPayment: () => selectPrintReceiptOnPayment,
  selectPrinterRulesForDetailsScreen: () => selectPrinterRulesForDetailsScreen,
  selectQSRSendAndPayActionButtonMode: () => selectQSRSendAndPayActionButtonMode,
  selectRegisterDiscountReasons: () => selectRegisterDiscountReasons,
  selectRegisterDiscountReasonsModalOptions: () => selectRegisterDiscountReasonsModalOptions,
  selectRegisterIsSeatManagementButtonSeatTagsOnly: () => selectRegisterIsSeatManagementButtonSeatTagsOnly,
  selectRegisterPrintHeldItems: () => selectRegisterPrintHeldItems,
  selectRegisterRestaurantMode: () => selectRegisterRestaurantMode,
  selectRegisterSeatManagementButtonFunction: () => selectRegisterSeatManagementButtonFunction,
  selectRegisterSettings: () => selectRegisterSettings,
  selectRegisterSettingsAndSectionId: () => selectRegisterSettingsAndSectionId,
  selectRegisterShowDoneButton: () => selectRegisterShowDoneButton,
  selectRegisterVoidReasons: () => selectRegisterVoidReasons,
  selectRestaurantMode: () => selectRestaurantMode,
  selectRoleCardsList: () => selectRoleCardsList,
  selectRoles: () => selectRoles,
  selectSeatingMode: () => selectSeatingMode,
  selectSelectedLayout: () => selectSelectedLayout,
  selectSettingsBarLocationText: () => selectSettingsBarLocationText,
  selectSettingsBreadCrumb: () => selectSettingsBreadCrumb,
  selectSettingsChangeData: () => selectSettingsChangeData,
  selectSettingsDataAndSectionId: () => selectSettingsDataAndSectionId,
  selectSettingsHasChanges: () => selectSettingsHasChanges,
  selectSettingsPlateFee: () => selectSettingsPlateFee,
  selectSettingsSelected: () => selectSettingsSelected,
  selectSettingsSelectedModeId: () => selectSettingsSelectedModeId,
  selectSettingsType: () => selectSettingsType,
  selectShowConfirmPopUpOnClearUnsentWithinAnItem: () => selectShowConfirmPopUpOnClearUnsentWithinAnItem,
  selectShowConfirmPopUpOnLeaveIncompleteItem: () => selectShowConfirmPopUpOnLeaveIncompleteItem,
  selectShowConfirmPopUpWhenSendingItemsInSeatView: () => selectShowConfirmPopUpWhenSendingItemsInSeatView,
  selectShowConfirmPopupToRemoveItem: () => selectShowConfirmPopupToRemoveItem,
  selectShowGiftCardButton: () => selectShowGiftCardButton,
  selectShowHotButtonsToggle: () => selectShowHotButtonsToggle,
  selectShowIndicatorWhenItemsOnTicketNotSentToKitchen: () => selectShowIndicatorWhenItemsOnTicketNotSentToKitchen,
  selectShowModTagBar: () => selectShowModTagBar,
  selectShowPopUpOnNavigateIfItemsOnTicketNotSentToKitchen: () => selectShowPopUpOnNavigateIfItemsOnTicketNotSentToKitchen,
  selectShowSeatsOnTableLayout: () => selectShowSeatsOnTableLayout,
  selectShowSentItemModificationsOnRegisterTicket: () => selectShowSentItemModificationsOnRegisterTicket,
  selectShowTimerOnTableLayout: () => selectShowTimerOnTableLayout,
  selectSomePrinterHasError: () => selectSomePrinterHasError,
  selectStreetLine1CurrentSettings: () => selectStreetLine1CurrentSettings,
  selectSuppressSeating: () => selectSuppressSeating,
  selectSuppressSuggestiveOrdering: () => selectSuppressSuggestiveOrdering,
  selectTerminalsForDetailsScreen: () => selectTerminalsForDetailsScreen,
  selectTicketElementSettings: () => selectTicketElementSettings,
  settingsDifferencesSelector: () => settingsDifferencesSelector,
  settingsErrorsSelector: () => settingsErrorsSelector,
  specialTagsSelector: () => specialTagsSelector
});

// src/helpers/settings/settings.ts
var getSettingsVersionWithStateCore = (state) => {
  const settingsType = selectActualSettingsType(state);
  switch (settingsType) {
    case "master" /* MASTER_SETTINGS */:
      return state.settings.versions.master;
    case "location" /* LOCATION_SETTINGS */:
      return state.settings.versions.location;
    case "remoteLocation" /* REMOTE_LOCATION_SETTINGS */:
      return state.settings.versions.remoteLocation;
  }
};
var getSettingsVersionCore = (state) => {
  return getSettingsVersionWithStateCore(state);
};
var getNewSettingsVersionCore = (payload, state) => {
  const settingsType = selectActualSettingsType(state);
  switch (settingsType) {
    case "master" /* MASTER_SETTINGS */:
      return payload.versions.master;
    case "location" /* LOCATION_SETTINGS */:
      return payload.versions.location;
    case "remoteLocation" /* REMOTE_LOCATION_SETTINGS */:
      return payload.versions.remoteLocation;
  }
};
var getCurrentSettingsCore = (state, settingsType) => {
  const { master, location, remoteLocation, versions } = state.settings;
  if (!settingsType) {
    settingsType = selectActualSettingsType(state);
  }
  switch (settingsType) {
    case "master" /* MASTER_SETTINGS */:
      return { settings: master, version: versions.master };
    case "location" /* LOCATION_SETTINGS */:
      return { settings: location, version: versions.location };
    case "remoteLocation" /* REMOTE_LOCATION_SETTINGS */:
      return {
        settings: remoteLocation,
        version: versions.remoteLocation || 0
      };
  }
};

// src/state/selectors/locationsSelectors.ts
var locationsSelectors_exports = {};
__export(locationsSelectors_exports, {
  selectShouldRenderLocationDropdown: () => selectShouldRenderLocationDropdown
});

// src/state/selectors/menuSelectors.ts
var menuSelectors_exports = {};
__export(menuSelectors_exports, {
  actualMenuVersionSelector: () => actualMenuVersionSelector,
  createItemSectionSelector: () => createItemSectionSelector,
  createItemSectionSelectorMultiple: () => createItemSectionSelectorMultiple,
  makeBucketAllowsMasterSaveSelector: () => makeBucketAllowsMasterSaveSelector,
  makeSelectFreshSheetData: () => makeSelectFreshSheetData,
  makeSelectIsActiveAndName: () => makeSelectIsActiveAndName,
  makeSelectItemData: () => makeSelectItemData,
  makeSelectItemDataAndMenuTypeVersions: () => makeSelectItemDataAndMenuTypeVersions,
  makeSelectMenuTypeVersions: () => makeSelectMenuTypeVersions,
  selectActualMenuType: () => selectActualMenuType,
  selectAllLocationIds: () => selectAllLocationIds,
  selectArrayOfHiddenItemsPerLocation: () => selectArrayOfHiddenItemsPerLocation,
  selectBarLocationText: () => selectBarLocationText,
  selectBreadCrumbs: () => selectBreadCrumbs,
  selectBreadCrumbsHasScreen: () => selectBreadCrumbsHasScreen,
  selectBreadCrumbsLength: () => selectBreadCrumbsLength,
  selectBucketSelected: () => selectBucketSelected,
  selectCardComboList: () => selectCardComboList,
  selectCardDiscountList: () => selectCardDiscountList,
  selectCardIngredientsList: () => selectCardIngredientsList,
  selectCardItemGroupsList: () => selectCardItemGroupsList,
  selectCardItemList: () => selectCardItemList,
  selectCardMenuTypeList: () => selectCardMenuTypeList,
  selectCardReportingGroupsList: () => selectCardReportingGroupsList,
  selectCardSpecialList: () => selectCardSpecialList,
  selectCategories: () => selectCategories,
  selectCategoriesAndSubcategories: () => selectCategoriesAndSubcategories,
  selectCategoriesDropdownList: () => selectCategoriesDropdownList,
  selectCategoriesSubcategories: () => selectCategoriesSubcategories,
  selectChangeData: () => selectChangeData,
  selectChangeDataDifferences: () => selectChangeDataDifferences,
  selectChangeDataId: () => selectChangeDataId,
  selectChangeDataOrChangeMassUpdateData: () => selectChangeDataOrChangeMassUpdateData,
  selectChangeMassUpdateData: () => selectChangeMassUpdateData,
  selectChangeMassUpdateDataSelectionCriteria: () => selectChangeMassUpdateDataSelectionCriteria,
  selectCombos: () => selectCombos,
  selectCurrentErrors: () => selectCurrentErrors,
  selectCurrentFreshSheet: () => selectCurrentFreshSheet,
  selectCurrentFreshSheetSectionId: () => selectCurrentFreshSheetSectionId,
  selectCurrentItem: () => selectCurrentItem,
  selectCurrentLocationHasMenusAvailable: () => selectCurrentLocationHasMenusAvailable,
  selectCurrentMenuItemById: () => selectCurrentMenuItemById,
  selectCurrentMenuType: () => selectCurrentMenuType,
  selectCurrentMenuTypes: () => selectCurrentMenuTypes,
  selectCurrentSectionId: () => selectCurrentSectionId,
  selectDataByBucketName: () => selectDataByBucketName,
  selectDiscounts: () => selectDiscounts,
  selectDisplayMode: () => selectDisplayMode,
  selectFinalDiffObject: () => selectFinalDiffObject,
  selectFreshSheetAndSectionId: () => selectFreshSheetAndSectionId,
  selectHasChanges: () => selectHasChanges,
  selectIngredients: () => selectIngredients,
  selectIsMassUpdate: () => selectIsMassUpdate,
  selectIsMenuCreationMode: () => selectIsMenuCreationMode,
  selectIsMenuMasterMode: () => selectIsMenuMasterMode,
  selectIsMenuRemoteLocationMode: () => selectIsMenuRemoteLocationMode,
  selectIsSaveEnabled: () => selectIsSaveEnabled,
  selectIsSet: () => selectIsSet,
  selectItemAndSectionId: () => selectItemAndSectionId,
  selectItemCustomId: () => selectItemCustomId,
  selectItemGroups: () => selectItemGroups,
  selectItems: () => selectItems,
  selectLastRearrangePreview: () => selectLastRearrangePreview,
  selectLastRearrangePreviewHotButtons: () => selectLastRearrangePreviewHotButtons,
  selectLocationCurrentIngredientsStatus: () => selectLocationCurrentIngredientsStatus,
  selectLocationCurrentModifierItemsStatus: () => selectLocationCurrentModifierItemsStatus,
  selectLocationDiscounts: () => selectLocationDiscounts,
  selectLocationGroupsObject: () => selectLocationGroupsObject,
  selectLocationItemDiscounts: () => selectLocationItemDiscounts,
  selectLocationItems: () => selectLocationItems,
  selectLocationList: () => selectLocationList,
  selectLocationListIds: () => selectLocationListIds,
  selectLocationMenu: () => selectLocationMenu,
  selectLocationMenuItemById: () => selectLocationMenuItemById,
  selectLocationMenuTypes: () => selectLocationMenuTypes,
  selectLocationOrderDiscounts: () => selectLocationOrderDiscounts,
  selectLocations: () => selectLocations,
  selectLocationsDropdownList: () => selectLocationsDropdownList,
  selectMasterCombos: () => selectMasterCombos,
  selectMasterIngredients: () => selectMasterIngredients,
  selectMasterItems: () => selectMasterItems,
  selectMasterMenu: () => selectMasterMenu,
  selectMasterSpecials: () => selectMasterSpecials,
  selectMenu: () => selectMenu,
  selectMenuMode: () => selectMenuMode,
  selectMenuPreviewAction: () => selectMenuPreviewAction,
  selectMenuSlice: () => selectMenuSlice,
  selectMenuState: () => selectMenuState,
  selectMenuTypeIdsWithCoursingDisabledAndRoundingDisabled: () => selectMenuTypeIdsWithCoursingDisabledAndRoundingDisabled,
  selectMenuTypeVersionsIds: () => selectMenuTypeVersionsIds,
  selectMenuTypeVersionsOfCurrentItem: () => selectMenuTypeVersionsOfCurrentItem,
  selectMenuTypes: () => selectMenuTypes,
  selectMenuTypesDropdownList: () => selectMenuTypesDropdownList,
  selectMenuTypesIdsWithCoursingDisabled: () => selectMenuTypesIdsWithCoursingDisabled,
  selectMenuTypesIdsWithCoursingEnabled: () => selectMenuTypesIdsWithCoursingEnabled,
  selectMenuTypesIdsWithRoundingDisabled: () => selectMenuTypesIdsWithRoundingDisabled,
  selectMenuTypesIdsWithRoundingEnabled: () => selectMenuTypesIdsWithRoundingEnabled,
  selectMenuVersion: () => selectMenuVersion,
  selectMenuVersions: () => selectMenuVersions,
  selectModifierGroups: () => selectModifierGroups,
  selectModifierItems: () => selectModifierItems,
  selectNumberOfMeuTypeVersions: () => selectNumberOfMeuTypeVersions,
  selectOriginalMenuData: () => selectOriginalMenuData,
  selectPreviewElements: () => selectPreviewElements,
  selectReportingGroups: () => selectReportingGroups,
  selectReportingGroupsDropdownList: () => selectReportingGroupsDropdownList,
  selectSelectedModeId: () => selectSelectedModeId,
  selectSpecials: () => selectSpecials,
  selectSubcategories: () => selectSubcategories,
  selectSubcategoriesDropdownList: () => selectSubcategoriesDropdownList,
  selectTotalLocations: () => selectTotalLocations
});
var HOUR_MS = 36e5;
var MINUTE_MS = 6e4;
var SECOND_MS = 1e3;
var DEFAULT_MILITARY_RANGE = {
  startTimeMilitary: 0,
  endTimeMilitary: 2400
};
var getDayKey = (timeZone) => {
  const today = DateTime.now().setZone(timeZone);
  return today.get("weekdayLong").toString().toLowerCase();
};
var getTimeZoneWithoutContinent = (timeZone) => {
  const dividedTimeZone = timeZone.split("/");
  dividedTimeZone.splice(0, 1);
  return dividedTimeZone.join("/");
};
var timeZoneToText = (timeZone) => {
  const timeZoneAbbreviation = DateTime.fromObject(
    {
      year: 2012,
      month: 1
    },
    { zone: timeZone }
  ).toFormat("ZZZZ");
  const dividedTimeZone = getTimeZoneWithoutContinent(timeZone).split("/").map((timeZonePart) => startCase(timeZonePart));
  const timeZoneString = dividedTimeZone.join(" - ");
  return `${timeZoneString} (${timeZoneAbbreviation})`;
};
var getMilitaryHour = (date) => {
  const dateLuxon = DateTime.fromISO(date).toUTC();
  return Number(dateLuxon.toFormat("HHmm"));
};
var getMilitaryHourLuxon = (date) => {
  return Number(date.toFormat("HHmm"));
};
var getMilitaryHourRange = (startDateString, endDateString, timeZone) => {
  const startDateTime = DateTime.fromISO(startDateString, { zone: timeZone });
  const endDateTime = DateTime.fromISO(endDateString, { zone: timeZone });
  const startTimeMilitary = getMilitaryHourLuxon(startDateTime);
  const endTimeMilitary = getMilitaryHourLuxon(endDateTime);
  if (startTimeMilitary < endTimeMilitary)
    return { startTimeMilitary, endTimeMilitary };
  else
    return {
      startTimeMilitary,
      endTimeMilitary: 2400 + endTimeMilitary
    };
};
var getHourMsCore = (date, timeZone, useTimeZone = true) => {
  const dateObj = getHourAndMinutesAndSecondsCore(date, timeZone, useTimeZone);
  return (dateObj.hour || 0) * HOUR_MS + (dateObj.minute || 0) * MINUTE_MS + (dateObj.second || 0) * SECOND_MS;
};
var dateTimeMsToTodayDateCore = (dateTime, useTimeZone = false, state) => {
  const timeZone = selectCurrentTimeZone(state);
  const lDate = DateTime.fromMillis(dateTime).toUTC();
  const currentDate = DateTime.fromFormat(
    lDate.toFormat("HH:mm:ss"),
    "HH:mm:ss",
    { zone: useTimeZone ? timeZone : "utc" }
  ).toUTC();
  return currentDate.toISO();
};
var dateTimeToSettingsTimeZoneCore = (dateTime, state) => {
  const timeZone = selectCurrentTimeZone(state);
  return DateTime.fromISO(dateTime, { zone: timeZone });
};
var dateTimeToCurrentTimeZoneCore = (dateTime, state) => {
  const timeZone = selectCurrentTimeZone(state);
  return DateTime.fromISO(dateTime, { zone: timeZone }).toISO();
};
var getHourAndMinutesAndSecondsCore = (date, timeZone, useTimeZone = false) => {
  let lDate = DateTime.fromISO(date, useTimeZone ? { zone: timeZone } : {});
  if (!useTimeZone) {
    lDate = lDate.toUTC();
  }
  return {
    hour: lDate.get("hour"),
    minute: lDate.get("minute"),
    second: lDate.get("second")
  };
};
var getSecondsUntilTrigger = (triggerTime, startTime, endTime) => {
  if (!startTime)
    return triggerTime;
  if (endTime)
    return 0;
  const now = DateTime.local();
  const start = DateTime.fromJSDate(new Date(startTime));
  const hypotheticalEnd = start.plus({ seconds: triggerTime });
  if (now > hypotheticalEnd)
    return 0;
  return Math.floor(hypotheticalEnd.diff(now, "seconds").seconds);
};
var getTimeDiffFromADateToNow = (fromDate, addExtraSeconds = 0, subtractSeconds = 0, formatUnitsArray = []) => {
  const formatArray = formatUnitsArray.length ? formatUnitsArray : ["days", "hours", "minutes", "seconds"];
  if (fromDate === NULLISH_DATE) {
    const returnValue = Duration.fromObject({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: addExtraSeconds
    }).toObject();
    for (const unit of formatArray) {
      returnValue[unit] = Math.abs(Number(returnValue[unit]));
    }
    return returnValue;
  }
  const diffTime = DateTime.utc().plus({ seconds: addExtraSeconds }).minus({ seconds: subtractSeconds }).diff(DateTime.fromJSDate(new Date(fromDate)), formatArray).toObject();
  for (const unit of formatArray) {
    diffTime[unit] = Math.abs(Number(diffTime[unit]));
  }
  return __spreadValues({}, diffTime);
};
var getTimeFromUTCCore = (date, state, supportLanguage = true, applyTimeZone = true, timeFormat = void 0) => {
  const timeZone = selectCurrentTimeZone(state);
  const _timeFormat = timeFormat || {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: applyTimeZone ? timeZone : "utc"
  };
  if (date === NULLISH_DATE)
    return "- - -";
  else if (supportLanguage) {
    return i18next.t("dateFormatter.time", {
      date,
      timeZone: applyTimeZone ? timeZone : "utc"
    });
  } else {
    const dateWithTimeZone = DateTime.fromISO(date, {
      zone: applyTimeZone ? timeZone : "utc"
    });
    return dateWithTimeZone.toLocaleString(_timeFormat);
  }
};
var getDateFromUTCCore = (date, state) => {
  const timeZone = selectCurrentTimeZone(state);
  const timeFormat = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    timeZone
  };
  if (date === NULLISH_DATE)
    return "- - -";
  const dateWithTimeZone = DateTime.fromISO(date, { zone: timeZone });
  return dateWithTimeZone.toLocaleString(timeFormat);
};
var getTimerString = (startTime, endTime) => {
  const remaining = endTime.diff(startTime, ["minutes", "seconds"]).toObject();
  return Duration.fromObject(remaining).toFormat("mm:ss");
};
var getNowUTCDate = () => DateTime.utc().toISO();
var dateTimeToUTCCore = (date, time, state) => {
  const timeZone = selectCurrentTimeZone(state);
  const todayDate = DateTime.now().toFormat("yyyy-MM-dd");
  const todayTime = DateTime.now().toFormat("HH:mm");
  const newDate = DateTime.fromISO(
    `${date ? `${date}T` : `${todayDate}T`}${time ? time : todayTime}`,
    {
      zone: timeZone
    }
  ).toUTC().toISO();
  return newDate;
};
var convert12hTo24hTime = (timeIn12h) => {
  const [time, hourModifier] = timeIn12h.split(" ");
  const splittedTime = time.split(":");
  let hours = splittedTime[0];
  const minutes = splittedTime[1];
  let newHours = 0;
  if (hours === "12") {
    hours = "00";
  }
  if (hourModifier === "PM") {
    newHours = parseInt(hours, 10) + 12;
  } else {
    newHours = parseInt(hours, 10);
  }
  return `${addLeadingZero(newHours)}:${minutes}`;
};
var getDateTimeNowWithTimeZoneCore = (state) => {
  const timeZone = selectCurrentTimeZone(state);
  return DateTime.now().setZone(timeZone);
};
var getDateWithTimeZoneCore = (date, state) => {
  const timeZone = selectCurrentTimeZone(state);
  const luxonDate = DateTime.fromJSDate(new Date(date)).setZone(timeZone);
  return luxonDate;
};
var getUTCTimeValueFrom12hTimeCore = (time12h, state) => {
  const newDate = dateTimeToUTCCore(
    null,
    convert12hTo24hTime(time12h),
    state
  ).split("T");
  const [hours, minutes] = newDate[1].split(":");
  return `${hours}:${minutes}`;
};
var getDateRangeStringCore = (startTime, endTime, state) => {
  const startDate = getDateWithTimeZoneCore(startTime, state);
  const endDate = getDateWithTimeZoneCore(endTime, state);
  return `${startDate.toFormat("HH:mm a")} - ${endDate.toFormat("HH:mm a")}`;
};
var isDateBeforeToday = (fromDate) => DateTime.fromJSDate(new Date(fromDate)).startOf("day") < DateTime.now().startOf("day");
var replaceUTCDateWithTodayString = (date, format, state) => {
  const timeZone = selectCurrentTimeZone(state);
  const today = DateTime.now().setZone(timeZone).toFormat("yyyy-MM-dd");
  const convertedDate = DateTime.fromISO(date, { zone: timeZone });
  const dateToCheck = convertedDate.toFormat("yyyy-MM-dd");
  if (today === dateToCheck && format) {
    const splittedFormat = format.split(" ");
    return `Today ${convertedDate.toFormat(
      splittedFormat.length === 3 ? `${splittedFormat[1]} ${splittedFormat[2]}` : `${splittedFormat[0]} ${splittedFormat[1]}`
    )}`;
  } else
    return date;
};
function isWithinLastSevenDays(isoTimeString, gracePeriodMs) {
  const now = /* @__PURE__ */ new Date();
  const time = new Date(isoTimeString);
  const diffInMs = now.getTime() - time.getTime();
  return diffInMs >= -(gracePeriodMs || 0) && diffInMs <= 7 * 24 * 60 * 60 * 1e3;
}
var getDateISOBasedInEndOfBusinessDay = (date, state) => {
  const endOfBusinessDay = selectEndOfBusinessDay(state);
  const endOfBusinessDay_time = DateTime.fromISO(endOfBusinessDay).toUTC().toFormat("hh:mm");
  const timeIn24h = convert12hTo24hTime(endOfBusinessDay_time);
  return dateTimeToUTCCore(
    DateTime.fromFormat(date, "yyyy/MM/dd").toFormat("yyyy-MM-dd"),
    timeIn24h,
    state
  );
};
var isValidDateTime = (time) => DateTime.fromISO(time).isValid;

// src/helpers/string.ts
var componentToHex = (color) => {
  const hex = color.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
};
var hexToRgb = (hexColor) => {
  const hexColorValue = hexColor.replace("#", "");
  if (hexColorValue.length !== 6)
    return [255, 255, 255];
  const aRgbHex = hexColorValue.match(/.{1,2}/g);
  if (aRgbHex === null)
    return [255, 255, 255];
  const aRgb = [
    parseInt(aRgbHex[0], 16),
    parseInt(aRgbHex[1], 16),
    parseInt(aRgbHex[2], 16)
  ];
  return aRgb;
};
var addLeadingZero = (value) => {
  return addLeadingZeros(value != null ? value : "", 2);
};
var addLeadingZeros = (value, digits = 2) => {
  const zeros = new Array(digits).fill("0").join("");
  return (zeros + value).slice(-digits);
};
var separateStringArrayByCommas = (array) => {
  return array.join(", ").replace(/,(?!.*,)/gim, " &");
};
var propagateString = (value, prevValue, propagateObj, deleteFromObjectIfStringEqual = false) => {
  const clonedPropagate = __spreadValues({}, propagateObj);
  Object.entries(clonedPropagate).forEach(([key, valueEntry]) => {
    if (!valueEntry || valueEntry === prevValue) {
      clonedPropagate[key] = value;
    } else if (deleteFromObjectIfStringEqual) {
      delete clonedPropagate[key];
    }
  });
  return clonedPropagate;
};
var formatDateCore = (date, format, state, replaceTodayDateWithString = false) => {
  if (!replaceTodayDateWithString)
    return dateTimeToSettingsTimeZoneCore(date, state).toFormat(format);
  const todayDate = replaceUTCDateWithTodayString(date, format, state);
  if (todayDate.includes("Today"))
    return todayDate;
  return dateTimeToSettingsTimeZoneCore(date, state).toFormat(format);
};
var DEFAULT_CONFIG = {
  includeUnits: false,
  includeDays: false,
  includeHours: true,
  includeMinutes: true,
  includeSeconds: true,
  addLeadingZeroToDays: true,
  addLeadingZeroToHours: true,
  addLeadingZeroToMinutes: true,
  addLeadingZeroToSeconds: true,
  includeDayUnitIfDays: false
};
var formatDurationObject = (time, config) => {
  config = __spreadValues(__spreadValues({}, DEFAULT_CONFIG), config);
  const {
    includeDays,
    includeHours,
    includeMinutes,
    includeSeconds,
    includeDayUnitIfDays,
    includeUnits,
    addLeadingZeroToDays,
    addLeadingZeroToHours,
    addLeadingZeroToMinutes,
    addLeadingZeroToSeconds
  } = config;
  const { days, hours, minutes, seconds } = cloneDeep(time);
  let formattedDays = addLeadingZeroToDays ? addLeadingZero(days) : days;
  let formattedHours = addLeadingZeroToHours ? addLeadingZero(hours) : hours;
  let formattedMinutes = addLeadingZeroToMinutes ? addLeadingZero(minutes) : minutes;
  let formattedSeconds = addLeadingZeroToSeconds ? addLeadingZero(seconds == null ? void 0 : seconds.toFixed(0)) : seconds == null ? void 0 : seconds.toFixed(0);
  formattedDays = includeDays && days ? `${formattedDays}d` : "";
  formattedHours = includeHours && (days || hours) ? `${formattedHours}h` : "";
  formattedMinutes = includeMinutes ? `${formattedMinutes}m` : "";
  formattedSeconds = includeSeconds ? `${formattedSeconds}s` : "";
  let formattedTime = includeUnits ? `${formattedDays}${includeDays ? ` ${formattedHours}` : formattedHours}${includeHours ? ` ${formattedMinutes}` : formattedMinutes}${includeMinutes ? ` ${formattedSeconds}` : formattedSeconds}` : `${includeDayUnitIfDays ? `${formattedDays} ` : formattedDays}${formattedHours}${formattedMinutes}${formattedSeconds}`;
  if (!includeUnits) {
    if (!includeDayUnitIfDays) {
      formattedTime = formattedTime.replace("d", ":");
    }
    formattedTime = formattedTime.replace("s", "");
    formattedTime = formattedTime.replace(/(h)/g, includeMinutes ? ":" : "");
    formattedTime = formattedTime.replace(/(m)/g, includeSeconds ? ":" : "");
  }
  return formattedTime.trim();
};
var truncateString = (str = "", length, omitEllipsis = false) => {
  if (str.length > length) {
    return str.slice(0, length) + (omitEllipsis ? "" : "...");
  }
  return str;
};
var concatStringsArrayWithAndText = (array) => {
  return array.length === 0 ? "" : `${array.slice(0, array.length === 1 ? 1 : array.length - 1).join(", ")}${array.length > 1 ? ` ${i18n_config_default.t("commonTexts.and")} ${array.slice(-1)}` : ""}`;
};

// src/helpers/factories/menu/hotButtonsFactory.ts
var hotButtonsFactoryCore = (hotButtons, items, modifierItems, menuTypes, categories, subcategories, openItems, stationNumber) => {
  if (Object.keys(hotButtons).length === 0)
    return [];
  const higherPosition = Object.values(hotButtons).reduce(
    (acc, hotButton) => hotButton.position > acc ? hotButton.position : acc,
    0
  );
  if (higherPosition === 0)
    return [];
  const numberOfPages = Math.ceil(higherPosition / 10);
  const newHotButtons = [];
  let startPosition = 1;
  let endPosition = 10;
  for (let i = 1; i <= numberOfPages; i++) {
    const hotButtonsPerPage = [];
    for (let j = startPosition; j <= endPosition; j++) {
      const currentHotButton = Object.values(hotButtons).find(
        (hotButton) => hotButton.position === j
      );
      if (currentHotButton) {
        const title = getHotButtonTitle(
          currentHotButton,
          items,
          modifierItems,
          menuTypes,
          categories,
          subcategories,
          openItems
        );
        hotButtonsPerPage.push(__spreadProps(__spreadValues({}, currentHotButton), {
          isEmpty: false,
          title: i18n_config_default.t(title),
          originalTitle: title,
          wasDeleted: false
        }));
      } else {
        hotButtonsPerPage.push(__spreadProps(__spreadValues({}, EMPTY_HOT_BUTTON), {
          id: `${addLeadingZero(stationNumber)}${j}-${Date.now()}`,
          position: j
        }));
      }
    }
    newHotButtons.push(hotButtonsPerPage);
    startPosition += 10;
    endPosition += 10;
  }
  return newHotButtons;
};
var arrayOfHiddenItemsPerLocationFactory = (items) => {
  return items.filter((item) => item.isHidden).reduce((acc, item) => [...acc, item.id.toString()], []);
};
var getHotButtonTitle = (HotButton, items, modifierItems, menuTypes, categories, subcategories, openItems) => {
  var _a, _b, _c, _d, _e;
  switch (HotButton.type) {
    case "cash-drawer" /* CASH_DRAWER */:
      return "menuScreen.hotButtons.openCashDrawer";
    case "customers" /* CUSTOMERS */:
      return "menuScreen.hotButtons.customers";
    case "gift-card" /* GIFT_CARD */:
      return "menuScreen.hotButtons.giftCards";
    case "id-scan" /* ID_SCAN */:
      return "menuScreen.hotButtons.scanId";
    case "open-item" /* OPEN_ITEM */: {
      return HotButton.bucketId ? openItems[HotButton.bucketId] ? openItems[HotButton.bucketId].posName : "" : "menuScreen.hotButtons.openItem";
    }
    case "item" /* ITEM */:
      return HotButton.bucketId && Object.keys(items).length > 0 ? (_a = items[HotButton.bucketId]) == null ? void 0 : _a.name : "";
    case "modifier-item" /* MODIFIER_ITEM */:
      return HotButton.bucketId && Object.keys(modifierItems).length > 0 ? (_b = modifierItems[HotButton.bucketId]) == null ? void 0 : _b.name : "";
    case "menuType" /* MENU_TYPE */:
      return HotButton.bucketId && Object.keys(menuTypes).length > 0 ? (_c = menuTypes[HotButton.bucketId]) == null ? void 0 : _c.name : "";
    case "fire" /* FIRE */:
      return "menuScreen.hotButtons.fire";
    case "category" /* CATEGORY */:
      return HotButton.bucketId && Object.keys(categories).length > 0 ? (_d = categories[HotButton.bucketId]) == null ? void 0 : _d.name : "";
    case "subcategory" /* SUBCATEGORY */:
      return HotButton.bucketId && Object.keys(subcategories).length > 0 ? (_e = subcategories[HotButton.bucketId]) == null ? void 0 : _e.name : "";
    case "new-course" /* NEW_COURSE */:
      return "menuScreen.hotButtons.newCourse";
    case "print-checks" /* PRINT_CHECKS */:
      return "menuScreen.hotButtons.printChecks";
    default:
      return "";
  }
};

// src/helpers/menu/menu.ts
var getMenuVersionState = (state) => {
  const menuType = selectActualMenuType(state);
  switch (menuType) {
    case "masterMenu" /* MASTER_MENU */:
      return state.menu.versions.master;
    case "locationMenu" /* LOCATION_MENU */:
      return state.menu.versions.location;
    case "remoteLocationMenu" /* REMOTE_LOCATION_MENU */:
      return state.menu.versions.remoteLocation;
  }
};
var getCurrentMenuCore = (state) => {
  const menuType = selectActualMenuType(state);
  switch (menuType) {
    case "masterMenu" /* MASTER_MENU */:
      return state.menu.masterMenu;
    case "locationMenu" /* LOCATION_MENU */:
      return state.menu.locationMenu;
    default:
      return state.menu.remoteLocationMenu;
  }
};
var selectIsMenuCreationMode = (state) => state.menu.changeData.mode === "create" /* CREATE */;
var selectMenuMode = (state) => state.menu.changeData.mode;
var selectChangeData = (state) => state.menu.changeData;
var selectChangeDataDifferences = (state) => state.menu.changeData.differences;
var selectChangeMassUpdateData = (state) => state.menu.changeMassUpdateData;
var selectIsMassUpdate = (state) => !!state.menu.changeMassUpdateData.data;
var selectChangeMassUpdateDataSelectionCriteria = (state) => state.menu.changeMassUpdateData.selectionCriteria;
var selectChangeDataOrChangeMassUpdateData = (state) => {
  if (state.menu.changeMassUpdateData.data) {
    return state.menu.changeMassUpdateData;
  }
  return state.menu.changeData;
};
var selectChangeDataId = (state) => state.menu.changeData.id;
var selectItemCustomId = (state) => {
  var _a;
  return (_a = selectCurrentItem(state)) == null ? void 0 : _a.customId;
};
var selectBucketSelected = (state) => {
  if (state.menu.changeMassUpdateData.data) {
    return state.menu.changeMassUpdateData.bucketSelected;
  }
  return state.menu.changeData.bucketSelected;
};
var selectCurrentItem = (state) => {
  if (state.menu.changeMassUpdateData.data) {
    return state.menu.changeMassUpdateData.data;
  }
  return state.menu.changeData.data;
};
var selectCurrentFreshSheet = (state) => {
  return state.menu.changeFreshSheetData.data;
};
var selectCurrentSectionId = (state) => {
  return state.menu.changeData.sectionId;
};
var selectCurrentFreshSheetSectionId = (state) => {
  return state.menu.changeFreshSheetData.sectionId;
};
var selectFinalDiffObject = (state) => {
  if (state.menu.changeMassUpdateData.data)
    return state.menu.changeMassUpdateData.finalDiffObject;
  return state.menu.changeData.finalDiffObject;
};
var selectMenuTypeVersionsOfCurrentItem = (state) => {
  var _a;
  return (_a = state.menu.changeData.data) == null ? void 0 : _a.menuTypeVersions;
};
var selectSelectedModeId = (state) => state.menu.selectedMode.id;
var selectMenuVersion = (state) => state.menu.selectedMode.menuVersion;
var selectBreadCrumbs = (state) => state.menu.breadCrumb;
var selectBreadCrumbsLength = (state) => selectBreadCrumbs(state).length;
var selectCurrentMenuType = (state) => state.menu.selectedMode.menuType;
var selectActualMenuType = (state) => state.menu.selectedMode.overrideMenuType || state.menu.selectedMode.menuType;
var selectMenuVersions = (state) => state.menu.versions;
var selectHasChanges = (state) => state.menu.changeData.hasChanges;
var selectCurrentErrors = (state) => state.menu.changeData.errors;
var selectLastRearrangePreview = (state) => state.menu.lastRearrangePreview;
var selectLastRearrangePreviewHotButtons = (state) => state.menu.lastRearrangePreview.hotButtons;
var selectIsMenuMasterMode = createSelector(
  selectCurrentMenuType,
  (menuType) => menuType === "masterMenu" /* MASTER_MENU */
);
var selectIsMenuRemoteLocationMode = createSelector(
  selectCurrentMenuType,
  (menuType) => menuType === "remoteLocationMenu" /* REMOTE_LOCATION_MENU */
);
var selectItemAndSectionId = createSelector(
  selectCurrentItem,
  selectCurrentSectionId,
  (itemData, sectionId) => ({
    itemData,
    sectionId
  })
);
var selectFreshSheetAndSectionId = createSelector(
  selectCurrentFreshSheet,
  selectCurrentFreshSheetSectionId,
  (freshSheetData, sectionId) => ({
    freshSheetData,
    sectionId
  })
);
var selectMenuSlice = (state) => state.menu;
var selectMenu = (state) => state.menu.selectedMode.currentMenu;
var selectMasterMenu = (state) => state.menu.masterMenu;
var selectLocationMenu = (state) => state.menu.locationMenu;
var selectItems = (state) => selectMenu(state).items;
var selectReportingGroups = (state) => selectMenu(state).reportingGroups;
var selectCombos = (state) => selectMenu(state).combos;
var selectMasterItems = (state) => state.menu.masterMenu.items;
var selectMasterIngredients = (state) => state.menu.masterMenu.ingredients;
var selectMasterCombos = (state) => state.menu.masterMenu.combos;
var selectMasterSpecials = (state) => state.menu.masterMenu.specials;
var selectLocationItems = (state) => state.menu.locationMenu.items;
var selectLocationMenuTypes = (state) => state.menu.locationMenu.menuTypes;
var selectCategories = (state) => selectMenu(state).categories;
var selectSubcategories = (state) => selectMenu(state).subcategories;
var selectModifierItems = (state) => selectMenu(state).modifierItems;
var selectMenuTypes = (state) => selectMenu(state).menuTypes;
var selectModifierGroups = (state) => selectMenu(state).modifierGroups;
var selectSpecials = (state) => selectMenu(state).specials;
var selectIngredients = (state) => selectMenu(state).ingredients;
var selectPreviewElements = (state) => state.menu.previewElements;
var selectMenuPreviewAction = (state) => state.menu.menuPreviewAction;
var selectCurrentMenuItemById = createSelector(
  selectItems,
  (_, itemId) => itemId,
  (items, itemId) => items[itemId]
);
var selectLocationMenuItemById = createSelector(
  selectLocationItems,
  (_, itemId) => itemId,
  (items, itemId) => items[itemId]
);
var selectMenuState = (state) => state.menu;
var selectCardItemList = createSelector(
  selectItems,
  selectCategories,
  selectSubcategories,
  selectMenuTypes,
  menuItemCardFactoryCore
);
var selectCardComboList = createSelector(
  selectCombos,
  selectCategories,
  selectSubcategories,
  selectMenuTypes,
  menuComboCardFactoryCore
);
var selectArrayOfHiddenItemsPerLocation = createSelector(
  selectCardItemList,
  arrayOfHiddenItemsPerLocationFactory
);
var selectCategoriesDropdownList = createSelector(
  selectCategories,
  dropdownAllCategoryOptionFactory
);
var selectReportingGroupsDropdownList = createSelector(
  selectReportingGroups,
  dropdownAllReportingGroupsOptionFactory
);
var selectSubcategoriesDropdownList = createSelector(
  selectSubcategories,
  dropdownSubcategoryOptionFactory
);
var selectMenuTypesDropdownList = createSelector(
  selectMenuTypes,
  dropdownMenuTypeOptionFactory
);
var selectCardSpecialList = createSelector(
  selectSpecials,
  menuSpecialCardFactory
);
var displayMode = (state) => state.settings.licenseSettings.displayMode;
var selectDisplayMode = createSelector(displayMode, (mode) => mode);
var selectCurrentMenuName = (state) => state.menu.selectedMode.name;
var selectBarLocationText = createSelector(
  selectCurrentMenuName,
  (name) => name
);
var createItemSectionSelector = (sectionId) => (_, next) => {
  return next.sectionId === sectionId ? false : next.sectionId !== "all" /* ALL */;
};
var createItemSectionSelectorMultiple = (sectionId, sectionId1) => (_, next) => {
  return next.sectionId === sectionId || next.sectionId === sectionId1 ? false : next.sectionId !== "all" /* ALL */;
};
var selectCurrentMenuTypes = (state) => {
  return selectMenu(state).menuTypes;
};
var selectMenuTypesIdsWithCoursingDisabled = createSelector(
  selectCurrentMenuTypes,
  (menuTypes) => Object.values(menuTypes).filter((menuType) => menuType.coursingType !== "coursing" /* COURSING */).map((menuType) => menuType.id)
);
var selectMenuTypesIdsWithCoursingEnabled = createSelector(
  selectCurrentMenuTypes,
  (menuTypes) => Object.values(menuTypes).filter((menuType) => menuType.coursingType === "coursing" /* COURSING */).map((menuType) => menuType.id)
);
var selectMenuTypesIdsWithRoundingDisabled = createSelector(
  selectCurrentMenuTypes,
  (menuTypes) => Object.values(menuTypes).filter((menuType) => menuType.coursingType !== "rounding" /* ROUNDING */).map((menuType) => menuType.id)
);
var selectMenuTypesIdsWithRoundingEnabled = createSelector(
  selectCurrentMenuTypes,
  (menuTypes) => Object.values(menuTypes).filter((menuType) => menuType.coursingType === "rounding" /* ROUNDING */).map((menuType) => menuType.id)
);
var selectMenuTypeIdsWithCoursingDisabledAndRoundingDisabled = createSelector(
  selectCurrentMenuTypes,
  (menuTypes) => Object.values(menuTypes).filter((menuType) => menuType.coursingType === "none" /* NONE */).map((menuType) => menuType.id)
);
var selectNumberOfMeuTypeVersions = createSelector(
  selectMenuTypeVersionsOfCurrentItem,
  selectCurrentMenuTypes,
  (menuTypeVersions, currentMenuTypes) => {
    return Object.values(menuTypeVersions).reduce((acc, menuTypeVersion) => {
      return currentMenuTypes[menuTypeVersion.menuTypeId].active ? acc + 1 : acc;
    }, 0);
  }
);
var selectItemGroups = (state) => selectMenu(state).itemGroups;
var selectCardMenuTypeList = createSelector(
  selectMenuTypes,
  menuTypeCardFactory
);
var selectCardItemGroupsList = createSelector(
  selectItemGroups,
  menuItemGroupCardFactory
);
var selectCardIngredientsList = createSelector(
  selectIngredients,
  menuIngredientCardFactory
);
var selectCardReportingGroupsList = createSelector(
  selectReportingGroups,
  menuReportingGroupCardFactory
);
var selectDiscounts = (state) => selectMenu(state).discounts;
var selectCardDiscountList = createSelector(
  selectDiscounts,
  menuDiscountCardFactory
);
var selectLocations = (state) => state.locations;
var selectTotalLocations = createSelector(
  selectLocations,
  (locationGroups) => Object.values(locationGroups).map(({ locations }) => locations.length).reduce((total, groupCount) => total + groupCount, 0)
);
var selectAllLocationIds = createSelector(
  selectLocations,
  (locationGroups) => Object.values(locationGroups).reduce((acc, group) => {
    return [...acc, ...group.locations.map((location) => location.id)];
  }, [])
);
var selectLocationGroupsObject = createSelector(
  selectLocations,
  locationGroupToLocationFactory
);
var selectLocationList = createSelector(
  selectLocations,
  locationsListFactory
);
var selectLocationsDropdownList = createSelector(
  selectLocationList,
  dropdownAllLocationOptionFactory
);
var selectLocationListIds = createSelector(
  selectLocationList,
  (locationsList) => locationsList.map((location) => location.id)
);
var selectIsSaveEnabled = createSelector(
  (state, organizationId) => ({ state, organizationId }),
  ({ state, organizationId }) => getIsSaveButtonEnabledCore(state, organizationId)
);
var selectCategoriesSubcategories = createSelector(
  selectCurrentItem,
  (_, menuTypeVersionId) => menuTypeVersionId,
  (itemData, menuTypeVersionId) => {
    var _a, _b;
    return (_b = (_a = itemData == null ? void 0 : itemData.menuTypeVersions) == null ? void 0 : _a[menuTypeVersionId]) == null ? void 0 : _b.categoriesSubcategories;
  }
);
var selectIsSet = createSelector(
  selectChangeDataOrChangeMassUpdateData,
  (data) => {
    return Boolean(data.bucketSelected);
  }
);
var selectCategoriesAndSubcategories = createSelector(
  selectCategories,
  selectSubcategories,
  (categories, subcategories) => ({
    categories,
    subcategories
  })
);
var selectMenuTypeVersionsIds = createSelector(
  selectCurrentItem,
  (itemData) => {
    if (itemData && itemData.menuTypeVersions) {
      return Object.keys(
        (itemData || ITEM_INITIAL_STATE).menuTypeVersions
      ).map((id) => Number(id));
    }
    return [];
  }
);
var makeSelectIsActiveAndName = (isSettings = false) => {
  const selectIsActiveAndName = createSelector(
    [(state) => state, (state, breadCrumb) => breadCrumb],
    (state, breadCrumb) => {
      if (!breadCrumb.statusPath)
        return {};
      const menuTypeId = breadCrumb.isItem ? get(
        state,
        `menu.${breadCrumb.statusPath.replace("active", "menuTypeId")}`
      ) : void 0;
      return {
        isActive: get(
          state,
          `${isSettings ? "settings" : "menu"}.${breadCrumb.statusPath}`
        ),
        menuTypeName: get(
          state,
          `menu.selectedMode.currentMenu.menuTypes.${menuTypeId}.name`
        )
      };
    }
  );
  return selectIsActiveAndName;
};
var makeSelectFreshSheetData = (currentSectionId) => {
  const createSelectorCustom = createSelectorCreator(
    defaultMemoize,
    createItemSectionSelector(currentSectionId)
  );
  return createSelectorCustom(
    selectFreshSheetAndSectionId,
    ({ freshSheetData }) => ({
      freshSheetData
    })
  );
};
var makeSelectItemData = (bucketName, currentSectionId, currentSectionId1) => {
  const createSelectorCustom = createSelectorCreator(
    defaultMemoize,
    currentSectionId1 ? createItemSectionSelectorMultiple(currentSectionId, currentSectionId1) : createItemSectionSelector(currentSectionId)
  );
  return createSelectorCustom(
    selectItemAndSectionId,
    selectBucketSelected,
    ({ itemData }, bucketSelected) => ({
      itemData: bucketSelected === bucketName ? itemData || getMenuInitialState(
        bucketName
      ) : getMenuInitialState(
        bucketName
      )
    })
  );
};
var makeSelectMenuTypeVersions = (currentSectionId) => {
  const createSelectorCustom = createSelectorCreator(
    defaultMemoize,
    createItemSectionSelector(currentSectionId)
  );
  return createSelectorCustom(selectItemAndSectionId, ({ itemData }) => ({
    menuTypeVersions: itemData ? itemData.menuTypeVersions : {}
  }));
};
var makeSelectItemDataAndMenuTypeVersions = (bucketName, currentSectionId) => {
  const createSelectorCustom = createSelectorCreator(
    defaultMemoize,
    createItemSectionSelector(currentSectionId)
  );
  return createSelectorCustom(
    selectItemAndSectionId,
    selectMenuTypeVersionsOfCurrentItem,
    ({ itemData, sectionId }, menuTypeVersions) => ({
      itemData,
      sectionId,
      menuTypeVersions
    })
  );
};
var actualMenuVersionSelector = (state) => getMenuVersionState(state);
var selectLocationModifierItems = (state) => state.menu.locationMenu.modifierItems;
var selectLocationIngredients = (state) => state.menu.locationMenu.ingredients;
var selectLocationCurrentModifierItemsStatus = createSelector(
  selectLocationModifierItems,
  (modifierItems) => {
    return Object.values(modifierItems).reduce(
      (acc, modifierItem) => {
        var _a;
        return __spreadProps(__spreadValues({}, acc), {
          [modifierItem.modifierItemId]: (_a = modifierItem.is86ed) != null ? _a : false
        });
      },
      {}
    );
  }
);
var selectLocationCurrentIngredientsStatus = createSelector(
  selectLocationIngredients,
  (ingredients) => {
    return Object.values(ingredients).reduce(
      (acc, ingredient) => {
        var _a;
        return __spreadProps(__spreadValues({}, acc), {
          [ingredient.ingredientId]: (_a = ingredient.is86ed) != null ? _a : false
        });
      },
      {}
    );
  }
);
var selectBreadCrumbsHasScreen = (state, screen) => selectBreadCrumbs(state).some((breadCrumb) => breadCrumb.screen === screen);
var selectDataByBucketName = (state, bucketName) => selectBucketSelected(state) === bucketName ? selectCurrentItem(state) : getMenuInitialState(bucketName);
var BUCKETS_FORBIDDEN_FROM_MASTER_SAVE = /* @__PURE__ */ new Set(["users"]);
var makeBucketAllowsMasterSaveSelector = (module) => {
  if (module === "reports") {
    return () => true;
  }
  const selectBucketName = module === "menu" ? selectBucketSelected : selectSettingsSelected;
  return createSelector(
    selectBucketName,
    (bucketName) => !bucketName || !BUCKETS_FORBIDDEN_FROM_MASTER_SAVE.has(bucketName)
  );
};
var selectOriginalMenuData = createSelector(
  selectChangeDataId,
  selectIsMenuCreationMode,
  selectMenu,
  selectBucketSelected,
  (changeDataId, isCreation, currentMenu, bucketSelected) => {
    if (!bucketSelected)
      return null;
    return isCreation ? getMenuInitialStateForSaving(bucketSelected) : currentMenu[bucketSelected][changeDataId];
  }
);
var selectCurrentLocationHasMenusAvailable = createSelector(
  selectCurrentMenuTypes,
  (menuTypeBucket) => Object.values(menuTypeBucket).some((menuType) => menuType.active)
);
var selectLocationDiscounts = (state) => state.menu.locationMenu.discounts;
var selectLocationItemDiscounts = createSelector(
  selectLocationDiscounts,
  (discountObject) => Object.values(discountObject).filter(
    (discount) => discount.active && discount.applyTo === "item" /* ITEM */
  )
);
var selectLocationOrderDiscounts = createSelector(
  selectLocationDiscounts,
  (discountObject) => Object.values(discountObject).filter(
    (discount) => discount.active && discount.applyTo === "order" /* ORDER */
  )
);

// src/state/selectors/locationsSelectors.ts
var selectShouldRenderLocationDropdown = createSelector(
  selectTotalLocations,
  (totalLocations) => totalLocations > 1
);

// src/state/selectors/settingsSelectors.ts
var selectSettingsHasChanges = (state) => state.settings.changeData.hasChanges;
var selectMasterSettings = (state) => state.settings.master;
var selectLocationSettings = (state) => state.settings.location;
var selectSettingsSelectedModeId = (state) => state.settings.selectedMode.id;
var selectSettingsBreadCrumb = (state) => state.settings.breadCrumb;
var selectSettingsChangeData = (state) => state.settings.changeData;
var selectCurrentSettings = (state) => state.settings.selectedMode.currentSettings;
var selectRegisterSettings = (state) => state.settings.selectedMode.currentSettings.register;
var selectIsSettingsCreationMode = (state) => state.settings.changeData.mode === "create" /* CREATE */;
var selectLocationCourses = (state) => selectRegisterSettings(state).courses;
var selectAllowOpenTabsOnTableLayout = (state) => selectRegisterSettings(state).allowOpenTabsOnTableLayout;
var selectShowTimerOnTableLayout = (state) => selectRegisterSettings(state).showTimerOnTableLayout;
var selectShowSeatsOnTableLayout = (state) => selectRegisterSettings(state).showSeatsOnTableLayout;
var selectAllowForTableButton = (state) => selectRegisterSettings(state).allowForTableButton;
var selectEnableDragDropForSeatPopover = (state) => selectRegisterSettings(state).enableDragDropForSeatPopover;
var selectIsShowPriceFreeEnabled = (state) => state.settings.selectedMode.currentSettings.registerTicket.showPriceFree;
var selectOpenItems = (state) => selectRegisterSettings(state).openItemTypes;
var selectGroupRounds = (state) => selectRegisterSettings(state).groupRounds;
var selectShowHotButtonsToggle = (state) => selectRegisterSettings(state).showHotButtonToggle;
var selectShowIndicatorWhenItemsOnTicketNotSentToKitchen = (state) => selectRegisterSettings(state).showIndicatorWhenItemsOnTicketNotSentToKitchen;
var selectShowPopUpOnNavigateIfItemsOnTicketNotSentToKitchen = (state) => selectRegisterSettings(state).showPopUpOnNavigateIfItemsOnTicketNotSentToKitchen;
var selectDefaultServiceAreaId = (state) => state.settings.licenseSettings.defaultServiceAreaId;
var selectDefaultServiceAreaOption = (state) => state.settings.licenseSettings.defaultServiceAreaOption;
var selectPrintReceiptOnPayment = (state) => state.settings.licenseSettings.printReceiptOnPayment;
var selectCurrentLicenseSettings = (state) => state.settings.licenseSettings;
var selectOpenItemTypes = (state) => selectRegisterSettings(state).openItemTypes;
var selectSuppressSuggestiveOrdering = (state) => state.settings.licenseSettings.suppressSuggestiveOrdering;
var selectPrintOrderNumberOnSend = (state) => state.settings.licenseSettings.printOrderNumberOnSend;
var selectCurrentLicenseDefaultCheckPrinterId = (state) => state.settings.licenseSettings.defaultCheckPrinterId;
var selectAllCoursesArray = createSelector(
  selectLocationCourses,
  (courses) => Object.values(courses)
);
var selectActiveCoursesArray = createSelector(
  selectAllCoursesArray,
  (courses) => courses.filter((course) => course.active)
);
var selectRegisterRestaurantMode = (state) => selectRegisterSettings(state).defaultRestaurantMode;
var selectLicenseRestaurantMode = (state) => state.settings.licenseSettings.overrideRestaurantMode;
var selectRegisterSeatManagementButtonFunction = (state) => selectRegisterSettings(state).seatManagementButtonFunction;
var selectRegisterIsSeatManagementButtonSeatTagsOnly = (state) => selectRegisterSettings(state).seatManagementButtonFunction === "seatTagsOnly" /* SEAT_TAGS_ONLY */;
var selectRestaurantMode = createSelector(
  selectLicenseRestaurantMode,
  selectRegisterRestaurantMode,
  (overrideRestaurantMode, defaultRestaurantMode) => {
    if (overrideRestaurantMode)
      return overrideRestaurantMode;
    return defaultRestaurantMode;
  }
);
var selectHasLocationOpenItems = createSelector(
  selectOpenItems,
  (openItemsTypes) => {
    if (isEmpty(openItemsTypes))
      return false;
    return Object.values(openItemsTypes).some(
      (openItemType) => openItemType.active
    );
  }
);
var selectCustomizerShape = (state) => selectRegisterSettings(state).customizerShape || "circle" /* CIRCLE */;
var selectShowSendItemsModalEnabled = (state) => selectRegisterSettings(state).showSendItemsModal;
var selectIsShowSendItemsModalEnabled = createSelector(
  selectRestaurantMode,
  selectShowSendItemsModalEnabled,
  (restaurantMode, isShowSendItemsModalEnabled) => restaurantMode === "qsr" /* QSR */ ? false : isShowSendItemsModalEnabled
);
var selectCustomizerPartition = (state) => selectRegisterSettings(state).customizerPartitions || "quarters" /* QUARTERS */;
var selectSuppressSeating = (state) => state.settings.licenseSettings.suppressSeating;
var selectIsSeating = (state) => selectRegisterSettings(state).seating;
var selectIsSeatingEnabledWithoutLicenseSuppress = createSelector(
  selectIsSeating,
  selectRestaurantMode,
  (isSeating, restaurantMode) => restaurantMode === "qsr" /* QSR */ ? false : isSeating
);
var selectIsSeatingModeEnabled = createSelector(
  selectSuppressSeating,
  selectIsSeating,
  selectRestaurantMode,
  (suppressSeating, seating, restaurantMode) => {
    return restaurantMode === "qsr" /* QSR */ ? false : suppressSeating ? false : seating;
  }
);
var selectIsSeatingEnabledButSuppressedOnDevice = createSelector(
  selectIsSeatingEnabledWithoutLicenseSuppress,
  selectSuppressSeating,
  (isSeatingEnabled, suppressSeating) => isSeatingEnabled && suppressSeating
);
var selectSeatingMode = (state) => selectRegisterSettings(state).seatingMode;
var selectIsQuantityBar = createSelector(
  selectIsSeatingModeEnabled,
  (state) => state.register.registerNavigation.ticketElementId,
  (isSeatingModeEnabled, ticketElementId) => !(isSeatingModeEnabled && !ticketElementId)
);
var selectAutoTriggering = (state) => selectRegisterSettings(state).autoTriggering;
var selectIsAutoTriggerEnabled = createSelector(
  selectAutoTriggering,
  (autoTriggering) => autoTriggering
);
var selectSuppressAllowForTableButton = (state) => state.settings.licenseSettings.suppressAllowForTableButton;
var selectIsForTableButtonEnabled = createSelector(
  selectSuppressAllowForTableButton,
  selectAllowForTableButton,
  () => true
  // TODO: uncomment when backend renames the field
  // (suppressAllowForTableButton, allowForTableButton) =>
  //   suppressAllowForTableButton ? false : allowForTableButton,
);
var selectCurrentSettingsName = (state) => state.settings.selectedMode.name;
var selectSettingsBarLocationText = createSelector(
  selectCurrentSettingsName,
  (name) => name
);
var selectSuppressShowSeatOneDescription = (state) => state.settings.licenseSettings.suppressShowSeatOneDescription;
var selectShowSeatOneDescription = (state) => selectRegisterSettings(state).showSeatOneDescription;
var selectIsSeatOneDescriptionEnabled = createSelector(
  selectRestaurantMode,
  selectSuppressShowSeatOneDescription,
  selectShowSeatOneDescription,
  (restaurantMode, suppressShowSeatOneDescription, showSeatOneDescription) => restaurantMode === "qsr" /* QSR */ ? false : suppressShowSeatOneDescription || showSeatOneDescription
);
var selectShowConfirmPopupToRemoveItem = (state) => selectRegisterSettings(state).showConfirmPopupToRemoveItem;
var selectShowConfirmPopUpOnLeaveIncompleteItem = (state) => selectRegisterSettings(state).showConfirmPopUpOnLeaveIncompleteItem;
var selectShowConfirmPopUpOnClearUnsentWithinAnItem = (state) => selectRegisterSettings(state).showConfirmPopUpOnClearUnsentWithinAnItem;
var selectShowConfirmPopUpWhenSendingItemsInSeatView = (state) => selectRegisterSettings(state).showConfirmPopUpWhenSendingItemsInSeatView;
var selectIsCoursing = (state) => selectRegisterSettings(state).coursing;
var selectIsCoursingEnabled = createSelector(
  selectRestaurantMode,
  selectIsCoursing,
  (restaurantMode, coursing) => restaurantMode === "tsr" /* TSR */ ? coursing : false
);
var selectCoursingModeActive = (state) => selectRegisterSettings(state).coursingMode;
var selectQSRSendAndPayActionButtonsOverride = (state) => state.settings.licenseSettings.qsrSendAndPayActionButtonsOverride;
var selectQSRSendAndPayActionButtonModeSetting = (state) => selectRegisterSettings(state).qsrSendAndPayActionButtons;
var selectQSRSendAndPayActionButtonMode = createSelector(
  selectQSRSendAndPayActionButtonsOverride,
  selectQSRSendAndPayActionButtonModeSetting,
  (overrideMode, currentMode) => overrideMode ? overrideMode : currentMode
);
var selectIsSendIndividualItemButtonDisabled = createSelector(
  selectRestaurantMode,
  selectQSRSendAndPayActionButtonMode,
  (restaurantMode, qsrButtonsMode) => restaurantMode === "qsr" /* QSR */ && qsrButtonsMode === "pay_only" /* PAY_ONLY */
);
var selectLicensePlateFee = (state) => state.settings.licenseSettings.splittingFee;
var selectPlateFee = (state) => selectRegisterSettings(state).splittingFee;
var selectSettingsPlateFee = createSelector(
  selectLicensePlateFee,
  selectPlateFee,
  (licensePlateFee, plateFee) => licensePlateFee === null ? plateFee : licensePlateFee
);
var selectOverrideDefaultMenuTypeId = (state) => state.settings.licenseSettings.overrideDefaultMenuTypeId;
var selectEGiftCardTerminalId = (state) => state.settings.licenseSettings.eGiftCardTerminalId;
var selectDefaultMenuTypeTimes = (state) => selectRegisterSettings(state).defaultMenuTypeTimes;
var selectDefaultMenuTypeId = (state) => selectRegisterSettings(state).defaultMenuTypeId;
var selectIsDefaultGuestCountOnNewOrder = (state) => selectRegisterSettings(state).defaultGuestCountOnNewOrder;
var selectIsShowGuestCountEnabled = (state) => selectRegisterSettings(state).showGuestCount;
var selectIsShowOrderDetailsForNewOrderTsrEnabled = (state) => selectRegisterSettings(state).showOrderDetailsForNewOrderTsr;
var selectIsShowOrderDetailsForNewOrderQsrEnabled = (state) => selectRegisterSettings(state).showOrderDetailsForNewOrderQsr;
var selectIsShowOrderDetailsForDefaultNewOrder = (state) => selectRegisterSettings(state).showOrderDetailsForDefaultNewOrder;
var selectIsShowOrderDetailsForNewOrderEnabled = createSelector(
  selectRestaurantMode,
  selectIsShowOrderDetailsForNewOrderQsrEnabled,
  selectIsShowOrderDetailsForNewOrderTsrEnabled,
  (restaurantMode, tsr, qsr) => {
    if (restaurantMode === "qsr" /* QSR */)
      return tsr;
    else
      return qsr;
  }
);
var selectIsGuestCountSetToZeroOnToGoOrders = (state) => selectRegisterSettings(state).setGuestCountToZeroOnToGoOrders;
var selectIsGuestCountSetToZeroWhenNoTable = (state) => selectRegisterSettings(state).setGuestCountToZeroWhenNoTable;
var selectSelectedLayout = (state) => {
  const selectedServiceArea = state.tableLayout.currentEditLayout.selectedServiceArea;
  const serviceAreaLayouts = state.tableLayout.currentEditData.serviceAreaLayouts;
  if (selectedServiceArea && serviceAreaLayouts) {
    return serviceAreaLayouts[selectedServiceArea.id];
  }
  return null;
};
var selectTicketElementSettings = createSelector(
  selectCurrentSettings,
  (currentSettings) => {
    const {
      registerTicket: {
        showTimestamps: showTimeStamps,
        modifierItemDisplayMode,
        displayDefaultModifiers,
        showPriceFree,
        showModifierItemPrice,
        autoCollapseLineItems,
        hideModGroupTitles,
        noForDeselectedDefaultModifiers,
        groupSameModItems,
        addSubForMultiSelectOff,
        separateSentItems
      },
      register: { autoTriggering: isAutoTriggeringEnabled }
    } = currentSettings;
    return {
      isAutoTriggeringEnabled,
      showTimeStamps,
      modifierItemDisplayMode,
      displayDefaultModifiers,
      showPriceFree,
      showModifierItemPrice,
      autoCollapseLineItems,
      hideModGroupTitles,
      noForDeselectedDefaultModifiers,
      groupSameModItems,
      addSubForMultiSelectOff,
      separateSentItems
    };
  }
);
var selectIsTicketAutoCollapSeLineItems = createSelector(
  selectCurrentSettings,
  (currentSettings) => currentSettings.registerTicket.autoCollapseLineItems
);
var selectEnforceItemGroupOrderForCombos = (state) => state.settings.location.register.enforceItemGroupOrderForCombos;
var selectLocationRoles = (state) => state.settings.location.roles;
var selectLocationGeneralSettings = (state) => state.settings.location.general;
var selectPinPadLayout = (state) => state.settings.location.general.pinpadLayout;
var selectAllowUserToBeLoggedIntoMultipleTablets = (state) => state.settings.location.general.allowUserToBeLoggedIntoMultipleTablets;
var selectCurrentSettingsData = (state) => state.settings.changeData.data;
var selectCurrentSettingsFinalDiffObject = (state) => state.settings.changeData.finalDiffObject;
var selectCurrentSettingsOriginalData = (state) => state.settings.changeData.originalData;
var selectCurrentSettingsSectionId = (state) => state.settings.changeData.sectionId;
var selectSettingsDataAndSectionId = createSelector(
  selectCurrentSettingsData,
  selectCurrentSettingsSectionId,
  (data, sectionId) => ({
    data,
    sectionId
  })
);
var selectLoggedUserRegisterPermissions = createSelector(
  selectLoggedInRoleId,
  selectLocationRoles,
  (loggedInRoleId, permissions) => {
    var _a;
    return (_a = permissions[loggedInRoleId]) == null ? void 0 : _a.registerPermissions;
  }
);
var selectLoggedUserCanDeleteOrders = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => registerPermissions.deleteOrders
);
var selectLoggedUserCanEditOtherUsersOrders = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => registerPermissions.editOtherUsersOrders
);
var selectLoggedUserCanOverrideLicenseEditingId = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => registerPermissions.overrideLicenseEditingId
);
var selectLoggedUserCanTransferOrders = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => registerPermissions.transferOrderOwner
);
var selectLoggedUserCanManageTables = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => registerPermissions.manageTables
);
var selectLoggedUserCanChangeMenuType = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => registerPermissions.showMenuSelector
);
var selectLoggedUserBehaviorOnNewOrder = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => registerPermissions.behaviorOnNewOrder
);
var selectLoggedUserTransferPayments = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => registerPermissions.transferPayments
);
var createSettingsSectionSelector = (sectionId) => (_, next) => {
  return next.sectionId === sectionId ? false : next.sectionId !== "all" /* ALL */;
};
var selectRegisterSettingsAndSectionId = (state) => {
  return {
    data: selectCurrentSettingsData(state),
    sectionId: state.settings.changeData.sectionId
  };
};
var selectRegisterDiscountReasons = (state) => selectRegisterSettings(state).discountReasons;
var selectAttachNoSeatToToGo = (state) => selectRegisterSettings(state).attachNoSeatToToGo;
var selectRegisterDiscountReasonsModalOptions = createSelector(
  selectRegisterDiscountReasons,
  discountReasonsDropdownFactory
);
var selectRegisterVoidReasons = createSelector(
  selectRegisterDiscountReasons,
  voidReasonsDropdownFactory
);
var selectSettingsType = (state) => state.settings.selectedMode.settingsType;
var selectActualSettingsType = (state) => state.settings.selectedMode.overrideSettingsType || selectSettingsType(state);
var areSettingsMasterModeSelector = (state) => state.settings.selectedMode.settingsType === "master" /* MASTER_SETTINGS */;
var selectIsSettingsRemoteLocationMode = (state) => state.settings.selectedMode.settingsType === "remoteLocation" /* REMOTE_LOCATION_SETTINGS */;
var selectShowTicketSeatBarSetting = (state) => selectRegisterSettings(state).ticketSeatBar;
var selectIsTicketSeatBarSettingEnabled = createSelector(
  selectIsSeatingModeEnabled,
  selectShowTicketSeatBarSetting,
  (isSeatingModeEnabled, showTicketSeatBar) => isSeatingModeEnabled ? showTicketSeatBar : "none" /* NONE */
);
var createSettingsErrorSelector = (sectionId) => (state) => {
  var _a;
  for (const value of Object.values(state.settings.changeData.errors || {})) {
    if (((_a = value.kind) == null ? void 0 : _a.section) === sectionId) {
      return true;
    }
  }
  return false;
};
var makeSelectSettingsData = (currentSectionId) => {
  const createSelectorCustom = createSelectorCreator(
    defaultMemoize,
    createSettingsSectionSelector(currentSectionId)
  );
  return createSelectorCustom(selectSettingsDataAndSectionId, ({ data }) => ({
    data
  }));
};
var selectIsSendCourseButtonEnabled = (state) => state.settings.selectedMode.currentSettings.registerTicket.showSendCourseButton;
var selectIsCateringAvailable = (state) => selectRegisterSettings(state).isCateringAvailable;
var selectIsDeliveryAvailable = (state) => selectRegisterSettings(state).isDeliveryAvailable;
var selectIsDineInAvailable = (state) => selectRegisterSettings(state).isDineInAvailable;
var selectIsToGoAvailable = (state) => selectRegisterSettings(state).isToGoAvailable;
var orderSeatTagsSelector = (state) => selectRegisterSettings(state).orderSeatTags;
var specialTagsSelector = (state) => selectRegisterSettings(state).specialTags;
var defaultMenuTypeTimesSelector = (state) => selectRegisterSettings(state).defaultMenuTypeTimes;
var modifierTagsSelector = (state) => selectRegisterSettings(state).modifierTags;
var adsSelector = (state) => selectRegisterSettings(state).ads;
var openItemTypesSelector = (state) => selectRegisterSettings(state).openItemTypes;
var selectShowModTagBar = (state) => selectRegisterSettings(state).showModTagBar;
var settingsErrorsSelector = (state) => state.settings.changeData.errors;
var devicesSelector = (state) => state.settings.location.devices;
var licensesSelector = (state) => state.settings.location.licenses;
var printersSelector = (state) => state.settings.location.devices.printers;
var selectOrderTypesAvailable = createSelector(
  selectIsCateringAvailable,
  selectIsDeliveryAvailable,
  selectIsDineInAvailable,
  selectIsToGoAvailable,
  (isCateringAvailable, isDeliveryAvailable, isDineInAvailable, isToGoAvailable) => ({
    isCateringAvailable,
    isDeliveryAvailable,
    isDineInAvailable,
    isToGoAvailable
  })
);
var selectOrderTypesAvailableOnViewTables = createSelector(
  selectIsCateringAvailable,
  selectIsDeliveryAvailable,
  selectIsToGoAvailable,
  (isCateringAvailable, isDeliveryAvailable, isToGoAvailable) => orderTypesAvailableFactory({
    isCateringAvailable,
    isDeliveryAvailable,
    isToGoAvailable
  })
);
var canSwipeAndDeleteTicketElementSelector = (state) => !state.register.registerNavigation.disablePreviewDeleteEnabled && state.register.registerNavigation.isPreviewMode || !state.register.registerNavigation.isPreviewMode;
var settingsDifferencesSelector = (state) => state.settings.changeData.differences;
var currentRegisterTicketSettingsSelector = (state) => state.settings.selectedMode.currentSettings.registerTicket;
var currentKitchenTicketSettingsSelector = (state) => state.settings.selectedMode.currentSettings.kitchenTicket;
var currentGuestCheckSettingsSelector = (state) => state.settings.selectedMode.currentSettings.guestCheck;
var currentGuestReceiptSettingsSelector = (state) => state.settings.selectedMode.currentSettings.guestReceipt;
var currentPrepStationsSelector = (state) => state.settings.selectedMode.currentSettings.prepStations.prepStations;
var selectDefaultPrepStation = (state) => state.settings.selectedMode.currentSettings.prepStations.defaultPrepStationId;
var currentPrepStationsSettingsSelector = (state) => state.settings.selectedMode.currentSettings.prepStations;
var selectLocationPrepStationsSettings = (state) => state.settings.location.prepStations;
var currentPrintingRulesSettingsSelector = (state) => state.settings.selectedMode.currentSettings.printerRules;
var currentLocationPrintingRulesSettingsSelector = (state) => state.settings.location.printerRules;
var currentLicenseSpecificPrintingRulesSettingsSelector = (state) => state.settings.selectedMode.currentSettings.licenseSpecificPrinterRules;
var currentLocationLicenseSpecificPrintingRulesSettingsSelector = (state) => state.settings.location.licenseSpecificPrinterRules;
var selectSettingsSelected = (state) => state.settings.changeData.settingsSelected;
var currentPrintingRulesSettingsModeSelector = (state) => {
  const settingsSelected = selectSettingsSelected(state);
  if (settingsSelected === "printerRules") {
    return state.settings.selectedMode.currentSettings.printerRules;
  } else if (settingsSelected === "licenseSpecificPrinterRules") {
    return state.settings.selectedMode.currentSettings.licenseSpecificPrinterRules[state.settings.changeData.id];
  }
};
var currentTaxesSettingsSelector = (state) => {
  return state.settings.selectedMode.currentSettings.taxes;
};
var currentPaymentsSettingsSelector = (state) => state.settings.selectedMode.currentSettings.payments;
var selectPaymentsDualPricing = (state) => currentPaymentsSettingsSelector(state).dualPricing;
var selectPaymentsListPrice = (state) => currentPaymentsSettingsSelector(state).listPrice;
var selectPaymentsCardCashPrice = (state) => currentPaymentsSettingsSelector(state).cardCashPrice;
var selectCustomTenders = createSelector(
  currentPaymentsSettingsSelector,
  (paymentsSettings) => paymentsSettings.customTenders
);
var selectIsDualPricingEnabled = createSelector(
  selectPaymentsDualPricing,
  selectPaymentsListPrice,
  selectPaymentsCardCashPrice,
  (dualPricing, listPrice, cardCashPrice) => ({
    dualPricing,
    listPrice,
    cardCashPrice
  })
);
var selectLocationShowNotificationMessageForPrinterErrors = (state) => state.settings.location.register.showNotificationMessageForPrinterErrors;
var selectLocationShowPrinterStatusNotifications = (state) => state.settings.location.register.showPrinterStatusNotifications;
var selectLocationFirePositionOnRegisterTicket = (state) => state.settings.location.register.firePositionOnRegisterTicket;
var selectDefaultTipInput = (state) => currentPaymentsSettingsSelector(state).defaultTipInput;
var currentGeneralSettingsSelector = (state) => state.settings.selectedMode.currentSettings.general;
var currentOnlineOrderingSettingsSelector = (state) => state.settings.selectedMode.currentSettings.online;
var currentLicenseSettingsSettingsSelector = (state) => state.settings.selectedMode.currentSettings.licenseSettings;
var selectLocationLicenseSettings = (state) => state.settings.location.licenseSettings;
var currentDevicesSelector = (state) => state.settings.selectedMode.currentSettings.devices;
var selectLocationDevices = (state) => state.settings.location.devices;
var selectLocationPrinters = (state) => {
  var _a;
  return (_a = selectLocationDevices(state)) == null ? void 0 : _a.printers;
};
var currentTabletsSelector = (state) => {
  var _a;
  return (_a = state.settings.selectedMode.currentSettings.devices) == null ? void 0 : _a.tablets;
};
var currentPrintersSelector = (state) => {
  var _a;
  return (_a = state.settings.selectedMode.currentSettings.devices) == null ? void 0 : _a.printers;
};
var currentTerminalsSelector = (state) => {
  var _a;
  return (_a = state.settings.selectedMode.currentSettings.devices) == null ? void 0 : _a.terminals;
};
var selectLocationTerminals = (state) => state.settings.location.devices.terminals;
var currentLicensesSelector = (state) => state.settings.selectedMode.currentSettings.licenses;
var actualSettingsVersionSelector = (state) => getSettingsVersionWithStateCore(state);
var selectCurrentTimeZone = (state) => state.settings.selectedMode.currentSettings.general.timeZone;
var selectGeneralSettings = (state) => state.settings.selectedMode.currentSettings.general;
var selectStreetLine1CurrentSettings = (state) => state.settings.selectedMode.currentSettings.general.streetLine1;
var selectDashboards = (state) => state.settings.selectedMode.currentSettings.dashboards;
var selectShowSentItemModificationsOnRegisterTicket = (state) => selectRegisterSettings(state).showSentItemModificationsOnRegisterTicket;
var selectRegisterShowDoneButton = (state) => selectRegisterSettings(state).showDoneButton;
var selectRegisterPrintHeldItems = (state) => selectRegisterSettings(state).printHeldItems;
var selectRoles = (state) => state.settings.selectedMode.currentSettings.roles;
var selectRoleCardsList = createSelector(
  selectRoles,
  selectUsers,
  settingsRolesCardFactory
);
var selectDashboardCardsList = createSelector(
  selectDashboards,
  settingsDashboardsCardFactory
);
var selectSomePrinterHasError = createSelector(
  printersSelector,
  (printers) => Object.values(printers).some(
    (printer) => printer.showInPrinterCenter && printer.status !== "active" /* ACTIVE */
  )
);
var selectLocationTaxes = (state) => state.settings.location.taxes;
var selectPrepStationsSettingsForDetailsScreen = createSelector(
  (state) => selectShouldRenderLocationDropdown(state),
  selectLocationPrepStationsSettings,
  currentPrepStationsSettingsSelector,
  (hasMultipleLocations, locationPrepStations, currentPrepStations) => hasMultipleLocations ? currentPrepStations : locationPrepStations
);
var selectPrepStationVersionsOfCurrentKitchenTicketSettings = (state) => {
  var _a;
  return (_a = selectCurrentSettingsData(state)) == null ? void 0 : _a.prepStationVersions;
};
var selectNumberOfPrepStationVersions = createSelector(
  selectPrepStationVersionsOfCurrentKitchenTicketSettings,
  (prepStationVersions) => {
    return Object.keys(prepStationVersions).length;
  }
);
var selectPrinterRulesForDetailsScreen = createSelector(
  (state) => selectShouldRenderLocationDropdown(state),
  currentLocationPrintingRulesSettingsSelector,
  currentPrintingRulesSettingsSelector,
  (hasMultipleLocations, locationPrinterRules, currentPrinterRules) => hasMultipleLocations ? currentPrinterRules : locationPrinterRules
);
var selectLicenseSpecificPrinterRulesForDetailsScreen = createSelector(
  (state) => selectShouldRenderLocationDropdown(state),
  currentLocationLicenseSpecificPrintingRulesSettingsSelector,
  currentLicenseSpecificPrintingRulesSettingsSelector,
  (hasMultipleLocations, locationLicenseSpecificPrinterRules, currentLicenseSpecificPrinterRules) => hasMultipleLocations ? currentLicenseSpecificPrinterRules : locationLicenseSpecificPrinterRules
);
var selectDevicesForDetailsScreen = createSelector(
  (state) => selectShouldRenderLocationDropdown(state),
  selectLocationDevices,
  currentDevicesSelector,
  (hasMultipleLocations, locationDevices, currentDevices) => hasMultipleLocations ? currentDevices : locationDevices
);
var selectLicenseSettingsForDetailsScreen = createSelector(
  (state) => selectShouldRenderLocationDropdown(state),
  selectLocationLicenseSettings,
  currentLicenseSettingsSettingsSelector,
  (hasMultipleLocations, locationLicenseSettings, currentLicenseSettings) => hasMultipleLocations ? currentLicenseSettings : locationLicenseSettings
);
var selectLicensesForDetailsScreen = createSelector(
  (state) => selectShouldRenderLocationDropdown(state),
  licensesSelector,
  currentLicensesSelector,
  (hasMultipleLocations, locationLicenses, currentLicenses) => hasMultipleLocations ? currentLicenses : locationLicenses
);
var selectTerminalsForDetailsScreen = createSelector(
  (state) => selectShouldRenderLocationDropdown(state),
  selectLocationTerminals,
  currentTerminalsSelector,
  (hasMultipleLocations, locationTerminals, currentTerminals) => hasMultipleLocations ? currentTerminals : locationTerminals
);
var selectPaymentsServiceCharges = createSelector(
  currentPaymentsSettingsSelector,
  (paymentsSettings) => paymentsSettings.serviceCharges
);
var selectEnableEGiftIntegration = createSelector(
  currentPaymentsSettingsSelector,
  (paymentsSettings) => paymentsSettings.enableEGiftIntegration
);
var selectCurrentTaxesSettingsSelector = createSelector(
  currentTaxesSettingsSelector,
  (currentTaxes) => currentTaxes
);
var selectLocationModifierTags = (state) => selectRegisterSettings(state).modifierTags;
var selectIsQSRModeActive = createSelector(
  selectRestaurantMode,
  (restaurantMode) => restaurantMode === "qsr" /* QSR */
);
var selectCurrentSettingsQSRSentToKitchenTrigger = (state) => state.settings.location.register.sendOrderToKitchenTrigger;
var selectCurrentSettingQSROnOrderClosed = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => {
    var _a;
    return (_a = registerPermissions == null ? void 0 : registerPermissions.qsrActionOnPay) != null ? _a : ROLE_INITIAL_STATE.registerPermissions.qsrActionOnPay;
  }
);
var selectCurrentSettingActionOnSendButton = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => {
    var _a;
    return (_a = registerPermissions == null ? void 0 : registerPermissions.navigationActionOnSendButton) != null ? _a : ROLE_INITIAL_STATE.registerPermissions.navigationActionOnSendButton;
  }
);
var selectCurrentSettingActionOnSendStayButton = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => {
    var _a;
    return (_a = registerPermissions == null ? void 0 : registerPermissions.navigationActionOnSendStayButton) != null ? _a : ROLE_INITIAL_STATE.registerPermissions.navigationActionOnSendStayButton;
  }
);
var selectCurrentSettingDefaultRegisterScreen = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => {
    var _a;
    return (_a = registerPermissions == null ? void 0 : registerPermissions.defaultRegisterScreen) != null ? _a : ROLE_INITIAL_STATE.registerPermissions.defaultRegisterScreen;
  }
);
var selectCurrentSettingNavigationActionOnCloseOrder = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => {
    var _a;
    return (_a = registerPermissions == null ? void 0 : registerPermissions.navigationActionOnCloseOrder) != null ? _a : ROLE_INITIAL_STATE.registerPermissions.navigationActionOnCloseOrder;
  }
);
var selectCurrentSettingNavigationActionOnTipPending = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => {
    var _a;
    return (_a = registerPermissions == null ? void 0 : registerPermissions.navigationActionOnTipPending) != null ? _a : ROLE_INITIAL_STATE.registerPermissions.navigationActionOnTipPending;
  }
);
var selectCurrentSettingNavigationActionOnPrintChecks = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => {
    var _a;
    return (_a = registerPermissions == null ? void 0 : registerPermissions.navigationActionOnPrintChecks) != null ? _a : ROLE_INITIAL_STATE.registerPermissions.navigationActionOnPrintChecks;
  }
);
var selectCurrentSettingNavigationActionOnFire = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => {
    var _a;
    return (_a = registerPermissions == null ? void 0 : registerPermissions.navigationActionOnFire) != null ? _a : ROLE_INITIAL_STATE.registerPermissions.navigationActionOnFire;
  }
);
var selectCurrentSettingDefaultOrderType = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => {
    var _a;
    return (_a = registerPermissions == null ? void 0 : registerPermissions.defaultOrderType) != null ? _a : ROLE_INITIAL_STATE.registerPermissions.defaultOrderType;
  }
);
var selectCurrentSettingAutoFilterTableTabsOrders = createSelector(
  selectLoggedUserRegisterPermissions,
  (registerPermissions) => {
    var _a;
    return (_a = registerPermissions == null ? void 0 : registerPermissions.autoFilterTableTabsOrders) != null ? _a : ROLE_INITIAL_STATE.registerPermissions.autoFilterTableTabsOrders;
  }
);
var selectShowGiftCardButton = (state) => state.settings.location.lockScreen.showGiftCardOptionsButton;
var selectIsKeepTipPendingOrdersAssociatedToTableSetting = (state) => selectRegisterSettings(state).keepTipPendingOrdersAssociatedToTable;
var selectIsKeepTipPendingOrdersAssociatedToTableEnabled = createSelector(
  selectRestaurantMode,
  selectIsKeepTipPendingOrdersAssociatedToTableSetting,
  (restaurantMode, settingEnabled) => restaurantMode === "tsr" /* TSR */ ? settingEnabled : false
);
var selectIsForceAllPaidOrdersToTipPendingEnabled = (state) => currentPaymentsSettingsSelector(state).forceAllPaidOrdersToTipPending;
var selectIsManualClosingRequiredPostTipEnabled = (state) => currentPaymentsSettingsSelector(state).requireManualClosingPostTip;
var selectIsMapLayoutDragAndDropEnabled = (state) => selectRegisterSettings(state).enableMapLayoutDragAndDrop;
var customTendersSelector = (state) => currentPaymentsSettingsSelector(state).customTenders;
var selectGeneralSettingsTranslationPath = createSelector(
  areSettingsMasterModeSelector,
  selectShouldRenderLocationDropdown,
  (isMasterMode, hasMultipleLocations) => {
    let locationPath = "location";
    if (isMasterMode) {
      locationPath = "master";
    }
    if (!hasMultipleLocations) {
      locationPath = "singleLocation";
    }
    return locationPath;
  }
);
var selectEndOfBusinessDay = (state) => currentGeneralSettingsSelector(state).endOfBusinessDay;

// src/helpers/factories/register/orderTypesAvailableFactory.ts
var expectedOrder = [
  "delivery" /* DELIVERY */,
  "to_go" /* TO_GO */,
  "catering" /* CATERING */
];
var orderTypesAvailableFactory = (orderTypesAvailable) => {
  const orderTypesAvailableTuple = Object.entries(orderTypesAvailable);
  const orderTypesAvailableArray = orderTypesAvailableTuple.filter((property) => property[1] === true).map((orderType) => {
    if (orderType[0] === "isToGoAvailable")
      return "to_go";
    return orderType[0].replace(/is|Available/g, "").toLowerCase();
  });
  return orderTypesAvailableArray.sort(
    (a, b) => (expectedOrder.indexOf(a) !== -1 ? expectedOrder.indexOf(a) : Infinity) - (expectedOrder.indexOf(b) !== -1 ? expectedOrder.indexOf(b) : Infinity)
  ).map((orderType) => orderType);
};
var getOrderTypesAvailableForOrderModalCore = (state, isAllOrderTypes = false) => {
  const isTogoAvailable = selectIsToGoAvailable(state);
  const restaurantMode = selectRestaurantMode(state);
  const selectedOrderType = state.tableLayout.currentEditLayout.selectedOrderType;
  const selectAvailableOrderTypes = selectOrderTypesAvailableOnViewTables(state);
  if (restaurantMode === "tsr" /* TSR */ && selectedOrderType === null && !isAllOrderTypes)
    return isTogoAvailable ? TSR_ORDER_TYPES : ["dine in" /* DINE_IN */];
  return ["dine in" /* DINE_IN */, ...selectAvailableOrderTypes];
};

export { DEFAULT_MILITARY_RANGE, HOUR_MS, MINUTE_MS, SECOND_MS, actualMenuVersionSelector, actualSettingsVersionSelector, addLeadingZero, addLeadingZeros, adsSelector, areSettingsMasterModeSelector, arrayOfHiddenItemsPerLocationFactory, canSwipeAndDeleteTicketElementSelector, componentToHex, concatStringsArrayWithAndText, convert12hTo24hTime, createItemSectionSelector, createItemSectionSelectorMultiple, createSettingsErrorSelector, createSettingsSectionSelector, currentDevicesSelector, currentGeneralSettingsSelector, currentGuestCheckSettingsSelector, currentGuestReceiptSettingsSelector, currentKitchenTicketSettingsSelector, currentLicenseSettingsSettingsSelector, currentLicenseSpecificPrintingRulesSettingsSelector, currentLicensesSelector, currentLocationLicenseSpecificPrintingRulesSettingsSelector, currentLocationPrintingRulesSettingsSelector, currentOnlineOrderingSettingsSelector, currentPaymentsSettingsSelector, currentPrepStationsSelector, currentPrepStationsSettingsSelector, currentPrintersSelector, currentPrintingRulesSettingsModeSelector, currentPrintingRulesSettingsSelector, currentRegisterTicketSettingsSelector, currentTabletsSelector, currentTaxesSettingsSelector, currentTerminalsSelector, customTendersSelector, dateTimeMsToTodayDateCore, dateTimeToCurrentTimeZoneCore, dateTimeToSettingsTimeZoneCore, dateTimeToUTCCore, defaultMenuTypeTimesSelector, devicesSelector, formatDateCore, formatDurationObject, getCurrentMenuCore, getCurrentSettingsCore, getDateFromUTCCore, getDateISOBasedInEndOfBusinessDay, getDateRangeStringCore, getDateTimeNowWithTimeZoneCore, getDateWithTimeZoneCore, getDayKey, getHotButtonTitle, getHourAndMinutesAndSecondsCore, getHourMsCore, getMenuVersionState, getMilitaryHour, getMilitaryHourLuxon, getMilitaryHourRange, getNewSettingsVersionCore, getNowUTCDate, getOrderTypesAvailableForOrderModalCore, getSecondsUntilTrigger, getSettingsVersionCore, getSettingsVersionWithStateCore, getTimeDiffFromADateToNow, getTimeFromUTCCore, getTimeZoneWithoutContinent, getTimerString, getUTCTimeValueFrom12hTimeCore, hexToRgb, hotButtonsFactoryCore, isDateBeforeToday, isValidDateTime, isWithinLastSevenDays, licensesSelector, locationsSelectors_exports, makeBucketAllowsMasterSaveSelector, makeSelectFreshSheetData, makeSelectIsActiveAndName, makeSelectItemData, makeSelectItemDataAndMenuTypeVersions, makeSelectMenuTypeVersions, makeSelectSettingsData, menuSelectors_exports, modifierTagsSelector, openItemTypesSelector, orderSeatTagsSelector, orderTypesAvailableFactory, printersSelector, propagateString, replaceUTCDateWithTodayString, selectActiveCoursesArray, selectActualMenuType, selectActualSettingsType, selectAllCoursesArray, selectAllLocationIds, selectAllowForTableButton, selectAllowOpenTabsOnTableLayout, selectAllowUserToBeLoggedIntoMultipleTablets, selectArrayOfHiddenItemsPerLocation, selectAttachNoSeatToToGo, selectBarLocationText, selectBreadCrumbs, selectBreadCrumbsHasScreen, selectBreadCrumbsLength, selectBucketSelected, selectCardComboList, selectCardDiscountList, selectCardIngredientsList, selectCardItemGroupsList, selectCardItemList, selectCardMenuTypeList, selectCardReportingGroupsList, selectCardSpecialList, selectCategories, selectCategoriesAndSubcategories, selectCategoriesDropdownList, selectCategoriesSubcategories, selectChangeData, selectChangeDataDifferences, selectChangeDataId, selectChangeDataOrChangeMassUpdateData, selectChangeMassUpdateData, selectChangeMassUpdateDataSelectionCriteria, selectCombos, selectCoursingModeActive, selectCurrentErrors, selectCurrentFreshSheet, selectCurrentFreshSheetSectionId, selectCurrentItem, selectCurrentLicenseDefaultCheckPrinterId, selectCurrentLicenseSettings, selectCurrentLocationHasMenusAvailable, selectCurrentMenuItemById, selectCurrentMenuType, selectCurrentMenuTypes, selectCurrentSectionId, selectCurrentSettingActionOnSendButton, selectCurrentSettingActionOnSendStayButton, selectCurrentSettingAutoFilterTableTabsOrders, selectCurrentSettingDefaultOrderType, selectCurrentSettingDefaultRegisterScreen, selectCurrentSettingNavigationActionOnCloseOrder, selectCurrentSettingNavigationActionOnFire, selectCurrentSettingNavigationActionOnPrintChecks, selectCurrentSettingNavigationActionOnTipPending, selectCurrentSettingQSROnOrderClosed, selectCurrentSettings, selectCurrentSettingsData, selectCurrentSettingsFinalDiffObject, selectCurrentSettingsOriginalData, selectCurrentSettingsQSRSentToKitchenTrigger, selectCurrentTaxesSettingsSelector, selectCurrentTimeZone, selectCustomTenders, selectCustomizerPartition, selectCustomizerShape, selectDashboardCardsList, selectDashboards, selectDataByBucketName, selectDefaultMenuTypeId, selectDefaultMenuTypeTimes, selectDefaultPrepStation, selectDefaultServiceAreaId, selectDefaultServiceAreaOption, selectDefaultTipInput, selectDevicesForDetailsScreen, selectDiscounts, selectDisplayMode, selectEGiftCardTerminalId, selectEnableDragDropForSeatPopover, selectEnableEGiftIntegration, selectEndOfBusinessDay, selectEnforceItemGroupOrderForCombos, selectFinalDiffObject, selectFreshSheetAndSectionId, selectGeneralSettings, selectGeneralSettingsTranslationPath, selectGroupRounds, selectHasChanges, selectHasLocationOpenItems, selectIngredients, selectIsAutoTriggerEnabled, selectIsCateringAvailable, selectIsCoursingEnabled, selectIsDefaultGuestCountOnNewOrder, selectIsDeliveryAvailable, selectIsDineInAvailable, selectIsDualPricingEnabled, selectIsForTableButtonEnabled, selectIsForceAllPaidOrdersToTipPendingEnabled, selectIsGuestCountSetToZeroOnToGoOrders, selectIsGuestCountSetToZeroWhenNoTable, selectIsKeepTipPendingOrdersAssociatedToTableEnabled, selectIsManualClosingRequiredPostTipEnabled, selectIsMapLayoutDragAndDropEnabled, selectIsMassUpdate, selectIsMenuCreationMode, selectIsMenuMasterMode, selectIsMenuRemoteLocationMode, selectIsQSRModeActive, selectIsQuantityBar, selectIsSaveEnabled, selectIsSeatOneDescriptionEnabled, selectIsSeatingEnabledButSuppressedOnDevice, selectIsSeatingEnabledWithoutLicenseSuppress, selectIsSeatingModeEnabled, selectIsSendCourseButtonEnabled, selectIsSendIndividualItemButtonDisabled, selectIsSet, selectIsSettingsCreationMode, selectIsSettingsRemoteLocationMode, selectIsShowGuestCountEnabled, selectIsShowOrderDetailsForDefaultNewOrder, selectIsShowOrderDetailsForNewOrderEnabled, selectIsShowOrderDetailsForNewOrderQsrEnabled, selectIsShowOrderDetailsForNewOrderTsrEnabled, selectIsShowPriceFreeEnabled, selectIsShowSendItemsModalEnabled, selectIsTicketAutoCollapSeLineItems, selectIsTicketSeatBarSettingEnabled, selectIsToGoAvailable, selectItemAndSectionId, selectItemCustomId, selectItemGroups, selectItems, selectLastRearrangePreview, selectLastRearrangePreviewHotButtons, selectLicenseSettingsForDetailsScreen, selectLicenseSpecificPrinterRulesForDetailsScreen, selectLicensesForDetailsScreen, selectLocationCourses, selectLocationCurrentIngredientsStatus, selectLocationCurrentModifierItemsStatus, selectLocationDevices, selectLocationDiscounts, selectLocationFirePositionOnRegisterTicket, selectLocationGeneralSettings, selectLocationGroupsObject, selectLocationItemDiscounts, selectLocationItems, selectLocationLicenseSettings, selectLocationList, selectLocationListIds, selectLocationMenu, selectLocationMenuItemById, selectLocationMenuTypes, selectLocationModifierTags, selectLocationOrderDiscounts, selectLocationPrepStationsSettings, selectLocationPrinters, selectLocationRoles, selectLocationSettings, selectLocationShowNotificationMessageForPrinterErrors, selectLocationShowPrinterStatusNotifications, selectLocationTaxes, selectLocationTerminals, selectLocations, selectLocationsDropdownList, selectLoggedUserBehaviorOnNewOrder, selectLoggedUserCanChangeMenuType, selectLoggedUserCanDeleteOrders, selectLoggedUserCanEditOtherUsersOrders, selectLoggedUserCanManageTables, selectLoggedUserCanOverrideLicenseEditingId, selectLoggedUserCanTransferOrders, selectLoggedUserTransferPayments, selectMasterCombos, selectMasterIngredients, selectMasterItems, selectMasterMenu, selectMasterSettings, selectMasterSpecials, selectMenu, selectMenuMode, selectMenuPreviewAction, selectMenuSlice, selectMenuState, selectMenuTypeIdsWithCoursingDisabledAndRoundingDisabled, selectMenuTypeVersionsIds, selectMenuTypeVersionsOfCurrentItem, selectMenuTypes, selectMenuTypesDropdownList, selectMenuTypesIdsWithCoursingDisabled, selectMenuTypesIdsWithCoursingEnabled, selectMenuTypesIdsWithRoundingDisabled, selectMenuTypesIdsWithRoundingEnabled, selectMenuVersion, selectMenuVersions, selectModifierGroups, selectModifierItems, selectNumberOfMeuTypeVersions, selectNumberOfPrepStationVersions, selectOpenItemTypes, selectOpenItems, selectOrderTypesAvailable, selectOrderTypesAvailableOnViewTables, selectOriginalMenuData, selectOverrideDefaultMenuTypeId, selectPaymentsCardCashPrice, selectPaymentsDualPricing, selectPaymentsListPrice, selectPaymentsServiceCharges, selectPinPadLayout, selectPrepStationVersionsOfCurrentKitchenTicketSettings, selectPrepStationsSettingsForDetailsScreen, selectPreviewElements, selectPrintOrderNumberOnSend, selectPrintReceiptOnPayment, selectPrinterRulesForDetailsScreen, selectQSRSendAndPayActionButtonMode, selectRegisterDiscountReasons, selectRegisterDiscountReasonsModalOptions, selectRegisterIsSeatManagementButtonSeatTagsOnly, selectRegisterPrintHeldItems, selectRegisterRestaurantMode, selectRegisterSeatManagementButtonFunction, selectRegisterSettings, selectRegisterSettingsAndSectionId, selectRegisterShowDoneButton, selectRegisterVoidReasons, selectReportingGroups, selectReportingGroupsDropdownList, selectRestaurantMode, selectRoleCardsList, selectRoles, selectSeatingMode, selectSelectedLayout, selectSelectedModeId, selectSettingsBarLocationText, selectSettingsBreadCrumb, selectSettingsChangeData, selectSettingsDataAndSectionId, selectSettingsHasChanges, selectSettingsPlateFee, selectSettingsSelected, selectSettingsSelectedModeId, selectSettingsType, selectShouldRenderLocationDropdown, selectShowConfirmPopUpOnClearUnsentWithinAnItem, selectShowConfirmPopUpOnLeaveIncompleteItem, selectShowConfirmPopUpWhenSendingItemsInSeatView, selectShowConfirmPopupToRemoveItem, selectShowGiftCardButton, selectShowHotButtonsToggle, selectShowIndicatorWhenItemsOnTicketNotSentToKitchen, selectShowModTagBar, selectShowPopUpOnNavigateIfItemsOnTicketNotSentToKitchen, selectShowSeatsOnTableLayout, selectShowSentItemModificationsOnRegisterTicket, selectShowTimerOnTableLayout, selectSomePrinterHasError, selectSpecials, selectStreetLine1CurrentSettings, selectSubcategories, selectSubcategoriesDropdownList, selectSuppressSeating, selectSuppressSuggestiveOrdering, selectTerminalsForDetailsScreen, selectTicketElementSettings, selectTotalLocations, separateStringArrayByCommas, settingsDifferencesSelector, settingsErrorsSelector, settingsSelectors_exports, specialTagsSelector, timeZoneToText, truncateString };
